/* eslint sort-keys-fix/sort-keys-fix: ["error", "asc", {natural: false}] */
const strings: { [key in string]: string } = {
  ACCEPT_ALL: 'Aceitar todos',
  ACCESS_DEACTIVATED: 'Acesso ao painel desativado',
  ACCESS_LEVEL_CHANGED: 'Permissões atualizadas: pode levar até uma hora para ser aplicado',
  ACCESS_REACTIVATED: 'Acesso ao painel reativado',
  ACCOUNT: 'Conta',
  ACCOUNTING_AND_AUDITING: 'Contabilidade e Auditoria',
  ACCOUNTS: 'Contas',
  ACCOUNTS_SUBTITLE: 'Gerencie sua organização e contas de clientes',
  ACCOUNT_ALREADY_EXISTS: 'A conta já existe',
  ACCOUNT_CREATION: 'Criação de conta',
  ACCOUNT_DETAILS: 'Detalhes da conta',
  ACCOUNT_DETAILS_COPIED: 'Detalhes da conta copiados para a área de transferência',
  ACCOUNT_HASH: 'N.° da conta',
  ACCOUNT_INFORMATION_ERROR:
    'Tivemos um problema temporário ao encontrar suas informações, por favor, tente novamente mais tarde.',
  ACCOUNT_NAME: 'Nome da conta',
  ACCOUNT_NAME_INVALID: 'Somente letras, números, espaços, hífens e underscores são permitidos',
  ACCOUNT_NAME_PLACEHOLDER: 'ex., Contas a Receber',
  ACCOUNT_NAME_REQUIRED: 'O nome da conta é obrigatório',
  ACCOUNT_NAME_TOO_LONG: 'O nome da conta é muito longo',
  ACCOUNT_NOT_FOUND: 'Conta não encontrada',
  ACCOUNT_NUMBER: 'Número da conta',
  ACCOUNT_NUMBER_COPIED: 'Número da conta copiado com sucesso',
  ACCOUNT_NUMBER_DETAILS: 'Número da conta',
  ACCOUNT_NUMBER_WITH_CURRENCY: 'Número da conta ({0})',
  ACCOUNT_SETUP: 'Configuração da conta',
  ACCOUNT_TYPE: 'Tipo de conta',
  ACCOUNT_TYPE_CHECKING: 'Conta corrente',
  ACCOUNT_TYPE_RUT: 'Conta RUT',
  ACCOUNT_TYPE_SAVINGS: 'Poupança',
  ACCOUNT_TYPE_VISTA: 'Conta à vista',
  ACH: 'ACH',
  ACTIONS: 'Ações',
  ACTION_REQUIRED: 'Ação necessária',
  ACTIVE: 'Ativo',
  ACTIVITY: 'Atividade',
  ADD: 'Adicionar',
  ADDITIONAL_DOCUMENTATION_REQUESTED: 'Documentação adicional foi solicitada para esta transação.',
  ADDRESS: 'Endereço',
  ADDRESS_COMPLEMENT: 'Complemento',
  ADD_ACCOUNT: 'Adicionar conta',
  ADD_APPROVAL_RULE: 'Adicionar regra',
  ADD_CONTACT: 'Adicionar contato',
  ADD_CONTACT_FLOW_MODAL_CURRENCY_DESCRIPTION: 'Moeda: {0}',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_ACH: 'ACH, Wire ou RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BI_FAST: 'BI-FAST (IDR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BOB_ACH: 'Transferência local (Bolívia)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CCE: 'CCE (PEN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CHATS: 'CHATS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CNAPS: 'CNAPS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_COP: 'ACH Colômbia',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CRYPTO: 'Stablecoins',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CVU: 'Transferência bancária (CVU ou CBU)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_EFT: 'EFT (CAD)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FAST: 'FAST (TRY)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FASTER_PAYMENTS: 'Faster Payments (GBP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_GHIPSS: 'GHIPSS (GHS)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IMPS: 'IMPS (INR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_INSTAPAY: 'InstaPay (PHP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IPP: 'IPP (AED)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_MOBILE_WALLET: 'Carteira móvel',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_NIP: 'NIP (NGN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PESALINK: 'PesaLink (KES)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PIX: 'Pix',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PROMPTPAY: 'PromptPay (THB)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTC: 'RTC (ZAR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTP: 'ACH, Wire ou RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SEPA: 'SEPA',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SPEI: 'Spei',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SWIFT: 'Swift',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_TEF: 'TEF (CLP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_WIRE: 'ACH, Wire ou RTP',
  ADD_DIGITAL_DOLLARS_LEGACY: 'Adicionar dolares digitais',
  ADD_DOCUMENTS: 'Adicionar documentos',
  ADD_FUNDS: 'Adicionar fundos',
  ADD_FX_MARKUP: 'Adicione sua margem FX',
  ADD_FX_MARKUP_DESCRIPTION:
    'Gere receita nas transações dos seus clientes adicionando uma margem. Seu spread será incluído na cotação acima.',
  ADD_NEW: 'Adicionar novo',
  ADD_NEW_CONTACT: 'Adicionar novo contato',
  ADD_NEW_CONTACT_WHICH_TYPE: 'Que tipo de contato você gostaria de adicionar?',
  ADD_NEW_CUSTOMER: 'Adicionar cliente',
  ADD_NEW_RECIPIENT: 'Adicionar novo destinatário',
  ADD_NEW_ROLE: 'Adicionar novo cargo',
  ADD_NEW_USER: 'Adicionar novo usuário',
  ADD_NEW_WITHDRAWAL_ACCOUNT: 'Adicionar nova conta de retirada',
  ADD_NICKNAME: 'Adicionar alias',
  ADD_PAYMENT_METHOD: 'Adicionar método de pagamento',
  ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE:
    'Você gostaria de adicionar um método de pagamento a um contato existente ou a um novo?',
  ADD_USDC: 'Adicionar USDC',
  ADD_USD_ACCOUNT: 'Adicionar conta USD',
  ADD_YOUR_BUSINESS_INFORMATION: 'Adicionar informações do seu negócio',
  ADMIN: 'Administrador',
  ADMINISTRATOR: 'Administrador',
  ADMIN_DESCRIPTION:
    'Gerenciamento de equipe, recursos de transações, visualizar e baixar histórico de transações e relatórios de atividades',
  ALL: 'Todos',
  ALL_TYPES: 'Todos os tipos',
  ALREADY_HAVE_ACCOUNT: 'Já tem uma conta?',
  AMOUNT: 'Valor',
  AMOUNT_ADDED_TO_WALLET: 'Valor adicionado à carteira',
  AMOUNT_BIGGER_THAN_BALANCE: 'O valor não pode ser maior que seu saldo (${0})',
  AMOUNT_EXCEEDS_AVAILABLE_EARNINGS: 'O valor não pode ser maior que seus ganhos disponíveis ({0})',
  AMOUNT_TO_CONVERT: 'Valor a converter',
  AND_READ_UNDERSTOOD_OUR: 'e que leu e entendeu nossa',
  ANNOUNCEMENT_ACKNOWLEDGE_AND_CLOSE: 'Confirmar e fechar',
  ANNOUNCEMENT_ACKNOWLEDGE_ERROR: 'Algo deu errado. Tente novamente.',
  ANNOUNCEMENT_BACK: 'Voltar',
  ANNOUNCEMENT_CLOSE: 'Fechar anúncio',
  ANNOUNCEMENT_FEATURE: 'Anúncio de funcionalidade',
  ANNOUNCEMENT_GOT_IT: 'Entendi',
  ANNOUNCEMENT_NEXT: 'Próximo',
  ANNOUNCEMENT_NEXT_STEP: 'Próximo passo',
  ANNOUNCEMENT_PREVIOUS_STEP: 'Passo anterior',
  ANY: 'Qualquer',
  AN_ERROR_OCCURRED: 'Ocorreu um erro desconhecido, por favor tente novamente mais tarde.',
  API_CREDENTIALS: 'Credenciais da API',
  API_CREDENTIALS_KEYS_SECTION_DESCRIPTION:
    'Use estes valores para autenticar sua integração com a API da Caliza. Trate os valores secretos como senhas.',
  API_CREDENTIALS_KEYS_SECTION_LABEL: 'Chaves e segredos',
  API_CREDENTIALS_UPDATE_ERROR: 'Não foi possível atualizar as credenciais da API',
  API_CREDENTIALS_UPDATE_SUCCESS: 'Credenciais da API atualizadas',
  API_CREDENTIALS_WEBHOOK_SECTION_DESCRIPTION:
    'Para onde enviamos os eventos de webhook e quem notificamos sobre a atividade do integrador.',
  API_CREDENTIALS_WEBHOOK_SECTION_LABEL: 'Configuração de webhook',
  API_ERROR_CORRIDOR_NOT_AVAILABLE:
    'Esta rota de transferência ainda não está disponível para a moeda e o destino selecionados. Entre em contato com o suporte para liberá-la.',
  API_ERROR_INSUFFICIENT_BALANCE:
    'Saldo insuficiente. Tente um valor menor ou adicione fundos à conta primeiro.',
  API_ERROR_PAYMENT_APPROVAL_NO_ELIGIBLE_APPROVER:
    'Este pagamento exige aprovação, mas sua organização não tem um aprovador elegível além de você. Um administrador precisa conceder a permissão de aprovação a outro membro da equipe.',
  API_ERROR_RECIPIENT_CRYPTO_NOT_APPROVED:
    'Este destinatário de cripto ainda não foi aprovado. Entre em contato com o suporte para liberá-lo.',
  API_ERROR_RECIPIENT_NOT_FOUND:
    'Destinatário não encontrado. Selecione um destinatário diferente.',
  API_ERROR_RECIPIENT_UNDER_REVIEW:
    'Este destinatário está em análise e ainda não pode ser usado em transferências. Entre em contato com o suporte.',
  API_ERROR_RECIPIENT_VALIDATION:
    'Não foi possível validar os dados do destinatário. Revise e tente novamente.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT: 'O valor está acima do máximo permitido para esta rota.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT_VALUE:
    'O valor está acima do máximo permitido para esta rota ({0}).',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT: 'O valor está abaixo do mínimo permitido para esta rota.',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT_VALUE:
    'O valor está abaixo do mínimo permitido para esta rota ({0}).',
  API_ERROR_TRANSACTION_MINIMUM_AMOUNT: 'O valor mínimo para esta transação é {0}.',
  API_ERROR_TRANSACTION_MINIMUM_NOT_CONFIGURED:
    'Não há valor mínimo configurado para esta rota. Entre em contato com o suporte.',
  API_ERROR_TRAVEL_RULE_OWNERSHIP_PROOF_REQUIRED:
    'Esta carteira auto-hospedada exige uma comprovação de posse verificada antes de simular ou enviar esta operação. Verifique a posse da carteira do destinatário selecionado primeiro.',
  API_ERROR_TRAVEL_RULE_PROOF_INVALID:
    'Não foi possível verificar a assinatura para este endereço de carteira. Assine com a carteira titular do endereço cadastrado.',
  API_USER: 'Usuário de API',
  API_USER_HELPER:
    'Usuários de API acessam a plataforma de forma programática e não passam pela configuração de autenticação de dois fatores.',
  APPEARANCE: 'Aparência',
  APPLY: 'Aplicar',
  APPROVAL_ADMIN_INITIATED_DESCRIPTION:
    'Quando desativado, transferências e saques iniciados por um administrador dispensam aprovação. Quando ativado, os administradores ficam sujeitos às mesmas regras que todos os demais.',
  APPROVAL_ADMIN_INITIATED_DISABLED_HINT:
    'Isso se aplica quando houver ao menos uma regra de aprovação ativada.',
  APPROVAL_ADMIN_INITIATED_LABEL:
    'Também exigir aprovação para transações iniciadas por administradores',
  APPROVAL_ADMIN_INITIATED_TOGGLE_ERROR:
    'Não foi possível atualizar a configuração. Tente novamente.',
  APPROVAL_NOTE_OPTIONAL: 'Nota (opcional)',
  APPROVAL_RULE: 'Regra de aprovação',
  APPROVAL_RULE_CURRENCY_ALREADY_USED: 'Já existe uma regra para esta moeda de carteira',
  APPROVAL_RULE_DELETE_ERROR: 'Não foi possível excluir a regra. Tente novamente.',
  APPROVAL_RULE_DELETE_SUCCESS: 'Regra excluída',
  APPROVAL_RULE_DISABLED: 'Desabilitada',
  APPROVAL_RULE_ENABLED: 'Habilitada',
  APPROVAL_RULE_SAVE_ERROR: 'Não foi possível salvar a regra. Tente novamente.',
  APPROVAL_RULE_SAVE_SUCCESS: 'Regra salva',
  APPROVAL_RULE_TOGGLE_ERROR: 'Não foi possível atualizar a regra. Tente novamente.',
  APPROVAL_RULE_VALUE_INVALID: 'O valor não pode ser negativo.',
  APPROVAL_RULE_ZERO_THRESHOLD_HINT:
    'Se {0} todas as transferências e saques da carteira Caliza selecionada serão retidos para aprovação.',
  APPROVE: 'Aprovar',
  APPROVED: 'Aprovado',
  APPROVED_DESC: 'Sua transação foi aprovada.',
  APP_ERROR_BOUNDARY_DESCRIPTION:
    'Ocorreu um erro inesperado. Por favor, atualize a página e tente novamente.',
  APP_ERROR_BOUNDARY_REFRESH: 'Atualizar página',
  APP_ERROR_BOUNDARY_TITLE: 'Algo deu errado',
  APP_ERROR_BOUNDARY_TRY_AGAIN: 'Tentar novamente',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_DESCRIPTION: 'Esta ação não é reversível.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_TITLE:
    'Tem certeza de que deseja excluir esta conta?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_DESCRIPTION: 'Esta ação não é reversível.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_TITLE:
    'Tem certeza de que deseja excluir este contato?',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_WITHOUT_HASH:
    'Tem certeza de que deseja sair sem fornecer um hash de transação?',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THESE_USERS_FROM_YOUR_TEAM: `Tem certeza que deseja remover {0} do seu time?`,
  ASSET_TYPE: 'Tipo de ativo',
  AVAILABLE_BALANCE: 'Ganhos disponíveis para resgate',
  AVAILABLE_BALANCE_TOOLTIP:
    'Este é o seu saldo de ganhos por margem. É independente do seu saldo de tesouraria em USDC.',
  AVAILABLE_BY_DEFAULT: 'Disponível por padrão',
  AWAITING_APPROVAL: 'Aguardando aprovação',
  AWAITING_APPROVAL_DESC: 'Sua transação está aguardando aprovação.',
  AWAITING_FUNDING_ALERT:
    'Esta transação tem uma taxa de câmbio garantida e está aguardando pagamento.',
  AWAITING_FUNDING_ALERT_TRANSACTIONS_LIST_ACTION: 'Veja os detalhes da transação para concluir.',
  AWAITING_FUNDING_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Pague esta transação antes que ela expire.',
  AWAITING_FUNDING_BANNER_PLURAL: 'Você tem {0} transações aguardando pagamento.',
  AWAITING_FUNDING_BANNER_SINGULAR: 'Você tem 1 transação aguardando pagamento.',
  AWAITING_FUNDING_FILTER_LABEL: 'Mostrar apenas transações aguardando pagamento',
  BACK: 'Voltar',
  BACK_TO_APPLICATION: 'Voltar para o aplicativo',
  BACK_TO_CUSTOMER: 'Voltar ao cliente',
  BACK_TO_DASHBOARD: 'Voltar ao painel',
  BACK_TO_LOGIN: 'Voltar ao login',
  BALANCE: 'Saldo',
  BANK: 'Banco',
  BANK_ACCOUNT: 'Conta bancária',
  BANK_ACCOUNT_INFORMATION: 'Informações da conta bancária',
  BANK_ACCOUNT_NUMBER: 'Número da conta bancária',
  BANK_ACCOUNT_TYPE: 'Tipo de conta bancária',
  BANK_ADDRESS: 'Endereço do banco',
  BANK_CODE: 'Código do banco',
  BANK_CODE_CNAPS: 'Código Bancário (CNAPS)',
  BANK_CODE_CNAPS_NOT_FOUND:
    'Banco não encontrado — digite o código CNAPS de 12 dígitos se não encontrar seu banco',
  BANK_INFORMATION: 'Informações bancárias',
  BANK_NAME: 'Nome do banco',
  BANK_NETWORK: 'Banco / rede',
  BENEFICIARIES: 'Beneficiários',
  BENEFICIARY_ADDRESS: 'Endereço do beneficiário',
  BENEFICIARY_NAME: 'Nome do beneficiário',
  BENEFICIARY_ONBOARDING_INVITED_BY: '{0} da {1} convidou você para o Caliza',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA:
    '{0} tem uma parceria com a Caliza para realizar pagamentos internacionais. Crie uma senha para acompanhar suas operações, rastrear fundos e pagamentos e baixar relatórios de transações.',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA_FOR:
    '{0} tem uma parceria com a Caliza para realizar pagamentos internacionais. Crie uma senha para rastrear fundos, ver pagamentos e baixar relatórios de transações de',
  BENEFICIARY_OR_RECIPIENT_CONTACT: 'Contato do beneficiário ou destinatário',
  BENEFICIARY_ROLE: 'Beneficiário',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN: 'Cadeia de suprimentos transfronteiriça',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN_DESCRIPTION:
    'Simplifique as contas a pagar e a receber internacionais',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT: 'Liquidação global para comerciantes',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT_DESCRIPTION:
    'Pagamentos instantâneos para marketplaces, e-commerce e plataformas',
  BENEFIT_INTERNATIONAL_PAYROLL: 'Folha de pagamento internacional',
  BENEFIT_INTERNATIONAL_PAYROLL_DESCRIPTION: 'Pague sua equipe internacional em USDC',
  BENEFIT_TREASURY_MANAGEMENT: 'Gestão de tesouraria',
  BENEFIT_TREASURY_MANAGEMENT_DESCRIPTION:
    'Otimize as operações de tesouraria internacional e os saldos de caixa',
  BRAZILIAN_PIX: 'Real brasileiro (Pix)',
  BRL1_WALLET: 'Carteira BRL1',
  BRL_MARKET_HOURS_ALERT:
    'Operações em BRL só podem ser concluídas durante o horário comercial: segunda a sexta-feira, das 9h00 às 15h40 BRT (exceto feriados).',
  BUSINESS: 'Empresa',
  BUSINESS_EMAIL: 'E-mail comercial',
  BUSINESS_INFORMATION: 'Informações da empresa',
  BUSINESS_NAME: 'Nome da empresa',
  BUSINESS_RELATIONSHIP: 'Relacionamento comercial',
  BY_CONFIRMING_EMAIL_AGREE: 'Ao confirmar seu e-mail, você concorda com nossos',
  CALIZA_ACCOUNT: 'Conta Caliza ({0})',
  CALIZA_BENEFITS: 'Benefícios da Caliza',
  CALIZA_DOES_NOT_CHARGE_DEPOSIT_FEES:
    'A Caliza não cobra nenhuma taxa de depósito. No entanto, sua carteira externa pode cobrar taxas para transferir fundos.',
  CALIZA_RATE: 'Cotação Caliza',
  CALIZA_RATE_TOOLTIP: 'A cotação Caliza inclui {0} de spread cambial',
  CALIZA_TERMS_AND_SERVICES: 'Termos e Serviços da Caliza',
  CALIZA_WALLET: 'Carteira Caliza',
  CALIZA_WALLET_BALANCE: 'Saldo da Carteira Caliza',
  CALIZA_WALLET_FEE_NOTE: 'Taxas podem ser aplicadas',
  CALLBACK_URL: 'URL de callback',
  CANCEL: 'Cancelar',
  CANCEL_TRANSFER: 'Cancelar transferência',
  CANT_SCAN_THE_CODE: 'Não consegue escanear o código?',
  CHAIN: 'Cadeia',
  CHAIN_ETHEREUM: 'Ethereum',
  CHAIN_POLYGON: 'Polygon',
  CHAIN_TRON: 'TRON',
  CHAIN_UNKNOWN: 'Desconhecido',
  CHANGE_PASSWORD_DESCRIPTION: 'Confirmação quando sua senha for alterada',
  CHANGE_PASSWORD_LABEL: 'Alterar senha',
  CHECKING: 'Conta corrente',
  CHECK_EMAIL_FOR_CODE: 'Por favor, verifique {0} para obter seu código de uso único',
  CHECK_HISTORY_DESCRIPTION:
    'Check your history to track the status of the transfer. Transaction details can take a few minutes before they appear.',
  CHECK_YOUR_PAYMENT_HISTORY_TO_TRACK_STATUS:
    'Verifique seu histórico de pagamentos para acompanhar o status do pagamento.',
  CHOOSE_DEPOSIT_AMOUNT: 'Escolha o valor do depósito',
  CITY: 'Cidade',
  CLABE_INVALID: 'A CLABE deve ter exatamente 18 dígitos',
  CLAIM: 'Resgatar',
  CLAIM_EARNINGS: 'Resgatar ganhos',
  CLEAR: 'Limpar',
  CLICK_HERE: 'clique aqui',
  CLIENT_ID: 'Client ID',
  CLIENT_SECRET: 'Client secret',
  CLOSE: 'Fechar',
  CODE_EXPIRED: 'O código expirou. Por favor, solicite um novo',
  CODE_RESENT: 'Código reenviado',
  COMING_SOON: 'Em breve',
  COMMA_AND_ONE: ', e um',
  COMMA_ONE: ', um',
  COMPANY: 'Empresa',
  COMPLETED: 'Concluído',
  COMPLETED_DESCRIPTION:
    'Receba notificações quando uma transferência estiver completa e o destinatário tiver recebido seus fundos',
  COMPLETED_LABEL: 'Completa',
  COMPLETED_STATUS: 'Concluído',
  CONFIRM: 'Confirmar',
  CONFIRMAR_NOVA_SENHA: 'Confirmar nova senha',
  CONFIRM_DEPOSIT: 'Confirmar Depósito',
  CONFIRM_EARNINGS_CLAIM: 'Confirmar resgate de ganhos',
  CONFIRM_INTERNAL_TRANSFER: 'Confirmar transferência interna',
  CONFIRM_NEW_PASSWORD: 'Confirmar nova senha',
  CONFIRM_PASSWORD: 'Confirmar senha',
  CONFIRM_PAYMENT: 'Confirmar pagamento',
  CONFIRM_WITHDRAWAL: 'Confirmar retirada',
  CONTACT: 'Contato',
  CONTACTS: 'Contatos',
  CONTACT_DETAILS: 'Detalhes do contato',
  CONTACT_EMAILS: 'E-mails de contato',
  CONTACT_EMAILS_HELPER: 'Lista de endereços de e-mail separados por vírgula',
  CONTACT_NICKNAME: 'Apelido do contato',
  CONTACT_TYPE: 'Tipo de contato',
  CONTINUE: 'Continuar',
  CONTINUE_WITH_GOOGLE: 'Continuar com o Google',
  CONVERSION_QUOTE: 'Cotação de conversão',
  CONVERSION_RATES: 'Cotações de conversão',
  CONVERT: 'Converter',
  CONVERTED_CURRENCY: 'Moeda convertida',
  CONVERT_ACCOUNT_BALANCE: 'Converter saldo da conta',
  CONVERT_SUCCESS: 'Conversão concluída com sucesso',
  COPIED: 'Copiado para a área de transferência',
  COPIED_TO_CLIPBOARD: 'Copiado para a área de transferência',
  COPY: 'Copiar',
  COPY_ALL: 'Copiar tudo',
  COPY_CLABE: 'Copiar CLABE',
  COPY_LINK: 'Copiar link',
  COUNTRY: 'País',
  COUNTRY_NOT_SUPPORTED_PREFIX: 'Não podemos enviar pagamentos para ',
  COUNTRY_NOT_SUPPORTED_SUFFIX: '.',
  COUNTRY_NOT_SUPPORTED_YET: 'Ainda não podemos enviar pagamentos para {0}.',
  COUNTRY_OF_RESIDENCE: 'País de residência',
  COUNTRY_RESTRICTED_PREFIX: 'Pagamentos para ',
  COUNTRY_RESTRICTED_SUFFIX: ' são restritos.',
  COUNT_OF_COUNT_COMPLETE: '{0} de {1} completo',
  CO_CC_LABEL: 'Cédula de Ciudadanía',
  CO_CE_LABEL: 'Cédula de Extranjería',
  CO_NIT_LABEL: 'Número de Identificación Tributaria',
  CO_SPECIAL_RESIDENCE_PERMIT: 'Permiso Especial de Permanencia',
  CREATE: 'Criar',
  CREATED: 'Criado',
  CREATED_DESC: 'Sua transação foi criada.',
  CREATED_WAITING_FUNDING_DESC: 'Sua transação foi criada e está aguardando o pagamento.',
  CREATE_A_CALIZA_ACCOUNT: 'Criar uma\nconta Caliza',
  CREATE_CUSTOM_ROLE_NAME: 'Crie um nome para este cargo personalizado:',
  CREATE_INTEGRATOR_SUCCESS: 'Integrador criado com sucesso',
  CREATE_TRANSACTIONS: 'Criar transações',
  CREATE_USD_ACCOUNT: 'Criar conta USD',
  CREATE_USD_ACCOUNT_DESCRIPTION:
    'Habilite uma conta em USD para este cliente e desbloqueie recursos bancários poderosos.',
  CREATE_USD_ACCOUNT_DISABLED_TOOLTIP:
    'A criação de contas USD não está habilitada, entre em contato com a equipe da Caliza para habilitá-la.',
  CREATE_USER_FAILED: 'Ocorreu um erro ao criar o usuário',
  CREATE_USER_SUCCESS: 'Usuário criado com sucesso',
  CREATING: 'Criando',
  CROSS_BORDER_SUPPLY_CHAIN: 'Cadeia de Suprimentos Transfronteiriça',
  CROSS_BORDER_SUPPLY_CHAIN_DESC: 'Simplifique contas a pagar e a receber internacionais',
  CRYPTO_ACCOUNT_INFORMATION: 'Informações da conta stablecoin',
  CRYPTO_DEPOSIT_COMPLETED_DESCRIPTION:
    'Verifique sua atividade para acompanhar o status da transferência. Os detalhes da transação podem levar alguns minutos para aparecer. ',
  CRYPTO_DEPOSIT_COMPLETED_TITLE: 'Assim que recebermos seus fundos, completaremos seu depósito',
  CRYPTO_HASH_TRANSFER_MODAL_DESCRIPTION:
    'O hash da transação para reconciliar automaticamente seu depósito recebido.',
  CRYPTO_HASH_TRANSFER_MODAL_TITLE:
    'Compartilhe o hash da transação fornecido pela sua carteira externa',
  CRYPTO_INTERNAL_TRANSFER: 'Transferência interna',
  CRYPTO_NETWORK: 'Rede',
  CRYPTO_NON_CUSTODIAL_WALLET: 'Carteira não custodial (auto-hospedada)',
  CRYPTO_THIRD_PARTY_ADDRESS_INFO:
    'Regulações exigem o endereço do titular da carteira para transferências a carteiras auto-hospedadas de terceiros.',
  CRYPTO_TRANSFER_COMPLETED_DESCRIPTION:
    'Verifique sua atividade para acompanhar o status da transferência. Os detalhes da transação podem levar alguns minutos para aparecer. ',
  CRYPTO_TRANSFER_COMPLETED_TITLE:
    'Assim que recebermos seus fundos, completaremos sua transferência',
  CRYPTO_TRANSFER_MODAL_DESCRIPTION:
    'Copie o hash da transação da sua carteira ou exchange e cole aqui para que possamos verificar seu depósito. Uma vez confirmado, sua transferência será concluída e aparecerá no seu histórico de transações.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_DESCRIPTION:
    'Envie fundos para o endereço da carteira abaixo. Assim que recebermos sua transferência, ela será concluída e aparecerá no seu histórico de transações.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_TITLE: 'Envie fundos para este endereço de carteira',
  CRYPTO_TRANSFER_MODAL_TITLE: 'Compartilhe o hash da transação para completar sua operação',
  CRYPTO_VASP: 'Provedor de Serviços de Ativos Virtuais (VASP)',
  CRYPTO_VASP_NAME: 'Nome do VASP',
  CRYPTO_VASP_OTHER: 'Outro (digitar nome do VASP)',
  CRYPTO_WALLET_ADDRESS: 'Endereço da carteira',
  CURRENCY_CONVERT_TO_STABLECOIN:
    '{0} será automaticamente convertido para uma stablecoin assim que recebermos seu depósito.',
  CURRENCY_TYPE: 'Tipo de moeda',
  CURRENCY_TYPE_LABEL: 'Tipo de moeda',
  CURRENT_PASSWORD: 'Senha atual',
  CUSTOM: 'Personalizado',
  CUSTOMER: 'Cliente',
  CUSTOMERS: 'Clientes',
  CUSTOMERS_SUBTITLE: 'Gerencie o onboarding de clientes',
  CUSTOMER_ACCOUNTS: 'Contas de clientes',
  CUSTOMER_ACCOUNT_BALANCES: 'Saldos do cliente',
  CUSTOMER_BALANCE: 'Saldo do Cliente',
  CUSTOMER_GETS: 'O cliente recebe',
  CUSTOMER_RATE_TOOLTIP: 'A cotação do cliente inclui sua margem FX de {0}',
  CUSTOMER_SUCCESS: 'Sucesso do Cliente',
  CUSTOMER_TYPE: 'Tipo de cliente',
  CUSTOMER_VERIFICATION_CREATE_ERROR: 'Falha ao criar a verificação do cliente',
  CUSTOMER_VERIFICATION_ERROR: 'Ocorreu um erro durante a verificação',
  CUSTOMER_VERIFICATION_INFO:
    'Por favor, complete a configuração para verificação e continue com as transferências',
  CUSTOMER_VERIFICATION_STARTED_SUCCESS: 'Verificação do cliente iniciada com sucesso',
  CUSTOMER_VERIFICATION_STATUS_INFO:
    'Por favor, complete a configuração para verificação e continue com as transferências',
  CUSTOMER_VERIFICATION_SUCCESS: 'Verificação concluída com sucesso',
  CVU: 'CVU',
  CVU_OR_CBU: 'CVU ou CBU',
  DARK: 'Escuro',
  DASHBOARD_ACCESS: 'Acesso ao painel',
  DASHBOARD_ACCESS_ALREADY_GRANTED: 'Este cliente já tem acesso ao painel',
  DASHBOARD_ACCESS_DESCRIPTION:
    'Dê a este cliente um acesso para administrar a própria conta: saldos, atividades, destinatários e pagamentos.',
  DASHBOARD_ACCESS_LOAD_ERROR: 'Não foi possível carregar o acesso ao painel deste cliente',
  DASHBOARD_ACCESS_NONE_YET: 'Este cliente ainda não tem acesso ao painel.',
  DASHBOARD_ACCESS_NONE_YET_HINT: 'Ele receberá um convite por e-mail para criar a senha.',
  DASHBOARD_ACCESS_REQUIRES_APPROVAL: 'Disponível quando a verificação deste cliente for aprovada.',
  DATE: 'Data',
  DATE_AND_TIME: 'Data e hora',
  DAY: 'Dia',
  DEACTIVATE: 'Desativar',
  DEACTIVATED: 'Desativado',
  DEACTIVATED_ON: 'Desativado em {0}',
  DEACTIVATE_ACCESS_DESCRIPTION:
    '{0} perderá o acesso ao painel imediatamente. Você pode reativar este acesso a qualquer momento.',
  DEACTIVATE_ACCESS_TITLE: 'Desativar o acesso ao painel?',
  DEACTIVATE_ACCOUNT: 'Desativar conta',
  DEACTIVATE_USER: 'Desativar usuário',
  DECLINED: 'Recusado',
  DEFAULT: 'Padrão',
  DELETE: 'Excluir',
  DELETE_ACCOUNT: 'Excluir conta',
  DELETE_APPROVAL_RULE: 'Excluir regra',
  DELETE_APPROVAL_RULE_CONFIRM_DESCRIPTION:
    'As transações não serão mais retidas para aprovação por esta regra.',
  DELETE_APPROVAL_RULE_CONFIRM_TITLE: 'Excluir esta regra de aprovação?',
  DELETE_CONTACT: 'Excluir contato',
  DELETE_CONTACT_SUCCESS: 'Contato excluído com sucesso',
  DELETE_PAYMENT_METHOD_SUCCESS: 'Método de pagamento excluído com sucesso',
  DEPARTMENT: 'Departamento',
  DEPOSIT: 'Depósito',
  DEPOSITING_FOR: 'Depositando para',
  DEPOSIT_ACTION: 'Depositar',
  DEPOSIT_COMPLETED: 'Depósito Concluído',
  DEPOSIT_COMPLETED_DESC: 'Seu depósito foi concluído.',
  DEPOSIT_COMPLETED_DESCRIPTION: 'Receba notificações quando um depósito for concluído',
  DEPOSIT_COMPLETED_LABEL: 'Concluído',
  DEPOSIT_COMPLETED_TITLE: 'Seus fundos foram adicionados',
  DEPOSIT_CREATED_DESCRIPTION: 'Receba notificações quando um depósito for criado',
  DEPOSIT_CREATED_LABEL: 'Criado',
  DEPOSIT_CREDENTIALS_DESCRIPTION:
    'Transfira USD do seu banco usando os detalhes de depósito fornecidos.\n\nCreditaremos sua conta automaticamente quando os fundos chegarem.',
  DEPOSIT_CREDENTIALS_TITLE: 'Envie fundos do seu banco',
  DEPOSIT_DETAILS: 'Detalhes do depósito',
  DEPOSIT_FAILED_DESCRIPTION: 'Receba notificações quando um depósito falhar',
  DEPOSIT_FAILED_LABEL: 'Falhou',
  DEPOSIT_FIAT_ACCOUNT_MODAL_DESCRIPTION:
    'Assim que recebermos seus fundos do seu banco, enviaremos automaticamente sua transferência e confirmaremos por e-mail e no seu histórico de transações.',
  DEPOSIT_FROM: 'Depósito de {0}',
  DEPOSIT_PENDING_DESCRIPTION:
    'Recebemos seu {0} e estamos processando seu depósito. Os depósitos podem levar até 4 minutos para serem concluídos. Você pode acompanhar o status do seu depósito em Atividade.',
  DEPOSIT_PENDING_TITLE: 'Estamos depositando seus fundos',
  DEPOSIT_RECEIVED: 'Depósito Recebido',
  DEPOSIT_RECEIVED_DESC: 'Seu depósito foi recebido.',
  DEPOSIT_STATUS: 'Status do depósito',
  DEPOSIT_TRANSACTION_HASH: 'Hash da transação de depósito',
  DESCRIPTION_OF_ROLE_OPTIONAL: 'Descrição do Cargo (Opcional)',
  DESELECT_ALL: 'Desmarcar todos',
  DESTINATION_COUNTRY: 'País da conta do destinatário',
  DESTINATION_TYPE: 'Tipo de destino',
  DETAILS: 'Detalhes',
  DEVICE_NAME: 'Nome do dispositivo',
  DEVICE_NAME_HELP: 'Opcional: Dê um nome a este dispositivo para identificação fácil',
  DEVICE_NAME_PLACEHOLDER: 'Meu Telefone',
  DISABLE: 'Desativar',
  DISABLE_TWO_FACTOR_AUTHENTICATION_TITLE: 'Tem certeza que deseja desativar o 2FA?',
  DISABLING: 'Desabilitando...',
  DOCUMENT_NUMBER_CPF_CNPJ: 'Número do documento (CPF/CNPJ)',
  DOCUMENT_NUMBER_INVALID:
    'O número do documento deve ser um CPF (11 dígitos) ou CNPJ (14 dígitos) válido',
  DOCUMENT_WITH_NAME_TEMPLATE: 'Documento {0}',
  DONE: 'Concluído',
  DONT_HAVE_ACCOUNT: 'Não tem uma conta?',
  DONT_SUPPORT_COUNTRY: 'Ainda não oferecemos suporte ao seu país',
  DOWNLOAD: 'Baixar',
  DOWNLOAD_COMPROVANTE_OPERACAO_TRANSACTION_DOCUMENT:
    'Comprovante de operação de pagamento internacional',
  DOWNLOAD_DETAILED_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Confirmação detalhada de pagamento',
  DOWNLOAD_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Confirmação de transação',
  DOWNLOAD_PDF: 'Baixar PDF',
  DOWNLOAD_TRANSACTION_DOCUMENTS: 'Baixar comprovantes de transação',
  EARNED: 'Ganho',
  EARNINGS: 'Ganhos',
  EARNINGS_AVAILABLE: 'Ganhos disponíveis: {0} {1}',
  EARNINGS_CLAIM_NO_FEES:
    'O resgate dos seus ganhos é isento de taxas. O valor total será transferido para o destino selecionado.',
  EARNINGS_CLAIM_SUCCESS: 'Seu resgate de ganhos foi enviado',
  EARNINGS_DASHBOARD: 'Painel de Ganhos',
  EARNINGS_DETAILS: 'Detalhes de ganhos',
  EDIT: 'Editar',
  EDIT_APPROVAL_RULE: 'Editar regra',
  EDIT_NICKNAME: 'Editar apelido',
  EDIT_RECIPIENT_TABS: 'Editar abas do destinatário',
  EMAIL: 'E-mail',
  EMAIL_INVALID_FORMAT: 'Formato de e-mail inválido',
  EMAIL_NOT_AVAILABLE: 'Este e-mail não pode ser usado',
  ENABLE: 'Habilitar',
  ENABLING: 'Habilitando...',
  ENTER_TOTP_CODE: 'Digite o código',
  ENTER_VERIFICATION_CODE: 'Digite o código de verificação',
  ENTER_VERIFICATION_CODE_DESCRIPTION:
    'Digite o código de 6 dígitos do seu aplicativo autenticador para completar a configuração',
  ERROR_DISPLAYING_ROW_DATA: 'Erro ao exibir dados da linha',
  ERROR_LOADING_CUSTOMER: 'Erro ao carregar os detalhes do cliente',
  ERROR_LOADING_EARNINGS: 'Erro ao carregar os dados de ganhos',
  ERROR_LOADING_PREFERENCES: 'Erro ao carregar preferências',
  EXCHANGE: 'Câmbio',
  EXCHANGE_COMPLETED: 'Câmbio concluído',
  EXCHANGE_COMPLETED_DESC: 'Seu câmbio foi concluído.',
  EXCHANGE_RATE_LOCK: 'Bloqueio de taxa de câmbio',
  EXISTING_CONTACT: 'Contato existente',
  EXPIRED: 'Expirada',
  EXPIRED_DESC: 'Esta transação expirou',
  EXTERNAL_ACCOUNT: 'Externo',
  EXTERNAL_ACCOUNT_ACH: 'Externo',
  EXTERNAL_ACCOUNT_COP: 'Externo',
  EXTERNAL_ACCOUNT_CVU: 'Externo',
  EXTERNAL_ACCOUNT_DESTINATION: 'Conta externa',
  EXTERNAL_ACCOUNT_ETH: 'Externo',
  EXTERNAL_ACCOUNT_NO_FEE_NOTE: 'Sem taxas adicionais',
  EXTERNAL_ACCOUNT_PIX: 'Externo',
  EXTERNAL_ACCOUNT_POLYGON: 'Externo',
  EXTERNAL_ACCOUNT_SPEI: 'Externo',
  EXTERNAL_ACCOUNT_SWIFT: 'Externo',
  EXTERNAL_ACCOUNT_TRON: 'Externo',
  EXTERNAL_ACCOUNT_WIRE: 'Externo',
  EXTERNAL_PAYMENT_REFERENCE_OPTIONAL: 'Referência de pagamento externo (Opcional)',
  EXTERNAL_RECIPIENT: 'Destinatário externo',
  FAILED: 'Falhou',
  FAILED_DESC: 'Seu pagamento falhou',
  FAILED_DESCRIPTION: 'Receba notificações quando uma transferência falhar',
  FAILED_LABEL: 'Falhou',
  FAILED_TO_LOAD_STATES: 'Falha ao carregar os estados do país selecionado.',
  FAILED_TO_LOAD_TRANSACTION_STATUS: 'Falha ao carregar o status da transação',
  FEATURE_NOT_AVAILABLE_DESCRIPTION:
    'Pedimos desculpas pelo inconveniente. Este recurso existe mas está temporariamente desativado. Por favor, verifique novamente mais tarde para atualizações.',
  FEATURE_NOT_AVAILABLE_TITLE: 'Recurso atualmente indisponível',
  FEE: 'Taxa',
  FEES: 'Taxas',
  FIAT_ACCOUNT_ACH: 'Conta Bancária (ACH)',
  FIAT_ACCOUNT_BI_FAST: 'Conta Bancária (BI-FAST)',
  FIAT_ACCOUNT_BOB_ACH: 'Conta Bancária (Bolívia)',
  FIAT_ACCOUNT_CCE: 'Conta Bancária (CCE)',
  FIAT_ACCOUNT_CHATS: 'Conta Bancária (CHATS)',
  FIAT_ACCOUNT_CNAPS: 'Conta Bancária (CNAPS)',
  FIAT_ACCOUNT_COP: 'COP',
  FIAT_ACCOUNT_CRYPTO: 'Carteira Stablecoin',
  FIAT_ACCOUNT_CVU: 'Transferência bancária (CVU ou CBU)',
  FIAT_ACCOUNT_EFT: 'Conta Bancária (EFT)',
  FIAT_ACCOUNT_FAST: 'Conta Bancária (FAST)',
  FIAT_ACCOUNT_FASTER_PAYMENTS: 'Conta Bancária (Faster Payments)',
  FIAT_ACCOUNT_GHIPSS: 'Conta Bancária (GHIPSS)',
  FIAT_ACCOUNT_IMPS: 'Conta Bancária (IMPS)',
  FIAT_ACCOUNT_INSTAPAY: 'Conta Bancária (InstaPay)',
  FIAT_ACCOUNT_IPP: 'Conta Bancária (IPP)',
  FIAT_ACCOUNT_MOBILE_WALLET: 'Carteira móvel',
  FIAT_ACCOUNT_NIP: 'Conta Bancária (NIP)',
  FIAT_ACCOUNT_PESALINK: 'Conta Bancária (PesaLink)',
  FIAT_ACCOUNT_PIX: 'Pix',
  FIAT_ACCOUNT_PROMPTPAY: 'Conta Bancária (PromptPay)',
  FIAT_ACCOUNT_RTC: 'Conta Bancária (RTC)',
  FIAT_ACCOUNT_RTP: 'Conta Bancária (RTP)',
  FIAT_ACCOUNT_SEPA: 'Conta Bancária (SEPA)',
  FIAT_ACCOUNT_SPEI: 'SPEI',
  FIAT_ACCOUNT_SWIFT: 'Conta Bancária (SWIFT)',
  FIAT_ACCOUNT_TEF: 'Conta Bancária (TEF)',
  FIAT_ACCOUNT_WIRE: 'Conta Bancária (Wire)',
  FIAT_INTERNAL_TRANSFER: 'Transferência interna',
  FILE_NAME_AND_SIZE_TEMPLATE: 'Nome do arquivo {0} - {1}',
  FILL_ALL_ENTRIES_AND_SUBMIT: 'Preencha todas as entradas e envie',
  FILL_OUT_DETAILS_FOR_NEW_MEMBER: 'Preencha os detalhes do novo membro',
  FILTER: 'Filtrar',
  FILTER_WITH_COUNT: 'Filtrar ({0})',
  FINANCE_AND_TREASURY: 'Finanças e Tesouraria',
  FIRST_NAME: 'Nome',
  FIRST_NAME_IS_EMPTY_ERROR: 'O nome não pode estar vazio',
  FOUR_STEPS_BEFORE_FIRST_PAYMENT: 'Quatro passos antes do seu primeiro pagamento',
  FROM: 'De',
  FROM_DATE: 'De (MM/AA)',
  FUNCTIONALITIES: 'Funcionalidades',
  FUNDING_METHOD: 'Método de financiamento',
  FUNDING_WITH: 'Financiamento com {0}',
  FX_LOCK_DEFAULT_LABEL: 'Padrão (2h)',
  FX_LOCK_DURATION: 'Duração: {0}h',
  FX_LOCK_HOURS: '{0}h',
  FX_LOCK_NO_EXTRA_SPREAD: 'Sem spread adicional',
  FX_LOCK_OPTION: '{0} — {1}',
  FX_LOCK_RATE_SPREAD: '(Spread do bloqueio de taxa: +{0})',
  FX_LOCK_RATE_TOOLTIP: 'O bloqueio de taxa inclui {0}% de spread cambial',
  FX_LOCK_SPREAD: '{0}% spread',
  FX_MARKUP_AMOUNT_AFTER_EXCHANGE: 'Valor após a conversão',
  FX_MARKUP_APPLY: 'Aplicar margem',
  FX_MARKUP_BPS_HINT: '100 bps = 1%',
  FX_MARKUP_BPS_LABEL: 'Margem (bps)',
  FX_MARKUP_CUSTOMER_PAYS: 'O cliente paga',
  FX_MARKUP_CUSTOMER_QUOTE_PREVIEW: 'Prévia da cotação do cliente',
  FX_MARKUP_CUSTOMER_RATE: 'Cotação do cliente',
  FX_MARKUP_CUSTOMER_RATE_TOOLTIP:
    'A taxa de câmbio após sua margem. Alguns meios de pagamento podem adicionar uma taxa de rede — veja-a nos detalhes da transação.',
  FX_MARKUP_EARNINGS: 'Ganhos de margem FX',
  FX_MARKUP_FIXED_BASED_ON_INPUT: 'Fixo com base na sua entrada',
  FX_MARKUP_MODAL_SUBTITLE: 'Defina seu spread para esta transação.',
  FX_MARKUP_MODAL_TITLE: 'Adicionar margem FX',
  FX_MARKUP_OUR_SPREAD: '(Nosso spread: +{0})',
  FX_MARKUP_RATE_BREAKDOWN: 'Detalhamento da cotação FX',
  FX_MARKUP_TOTAL_SPREAD: '{0} spread total',
  FX_MARKUP_YOUR_SPREAD: '(Seu spread: +{0})',
  FX_MARKUP_YOU_EARN: 'Você ganha',
  FX_RATE_LOCK: 'Duração do bloqueio de taxa',
  FX_RATE_LOCK_DESCRIPTION:
    'Bloqueie sua taxa de câmbio por mais tempo. Bloqueios mais longos têm um spread maior.',
  GENERATE_STATEMENT_DESCRIPTION:
    'Selecione uma conta e um período. O extrato inclui os saldos inicial e final.',
  GENERATE_STATEMENT_TITLE: 'Gerar um extrato',
  GET_HELP: 'Obter ajuda',
  GLOBAL_BUSINESS_ACCOUNTS: 'Contas empresariais globais em USDC',
  GLOBAL_MERCHANT_SETTLEMENT: 'Liquidação de Comerciante Global',
  GLOBAL_MERCHANT_SETTLEMENT_DESC:
    'Pagamentos instantâneos para marketplaces, e-commerce e plataformas',
  GOT_IT: 'Entendi',
  GROSS_AMOUNT: 'Valor bruto',
  HELP: 'Ajuda',
  HIDE: 'Ocultar',
  HIDE_PASSWORD: 'Ocultar senha',
  HIDE_ROLE_DETAILS: 'Ocultar detalhes do cargo',
  HOME: 'Início',
  HOUR: 'hora',
  HOURS: 'horas',
  HOW_IT_WORKS_USD_ACCOUNTS_1: 'Obtenha detalhes ACH / Wire / SWIFT para receber depósitos USD',
  HOW_IT_WORKS_USD_ACCOUNTS_2: 'Envie pagamentos em seu nome',
  HOW_IT_WORKS_USD_ACCOUNTS_3: 'Crie múltiplas contas para automatizar a conciliação',
  HOW_IT_WORKS_USD_ACCOUNTS_DESC: 'Adicione dados bancários para receber e enviar USD em seu nome.',
  HOW_IT_WORKS_USD_ACCOUNTS_TITLE: 'Detalhes da conta USD',
  HOW_IT_WORKS_USD_BALANCE_1:
    'Financie USD a partir de depósitos locais (SPEI/Pix) ou de seus saldos Caliza USDC/USDT',
  HOW_IT_WORKS_USD_BALANCE_2: 'Envie pagamentos a partir do seu saldo USD (remetente: Caliza)',
  HOW_IT_WORKS_USD_BALANCE_3: 'Sem detalhes de conta USD para depósitos ACH / Wire / SWIFT',
  HOW_IT_WORKS_USD_BALANCE_DESC: 'Mantenha USD e envie pagamentos mundialmente.',
  HOW_IT_WORKS_USD_BALANCE_TITLE: 'Saldo USD',
  HOW_NAMED_PAYMENTS_WORK_BODY:
    'Pagamentos enviados em nome do seu cliente exigem dados de conta USD para esse cliente. Se os dados de conta USD ainda não foram criados, o cliente ainda pode financiar pagamentos a partir do saldo USD, mas o destinatário verá o seu nome no pagamento.',
  HOW_NAMED_PAYMENTS_WORK_TITLE: 'Como funcionam os pagamentos nominais',
  HOW_THIS_WORKS: 'Como funciona',
  IBAN: 'IBAN',
  IBAN_ACCOUNT_NUMBER: 'IBAN / Número da conta',
  IBAN_DETAILS: 'IBAN',
  IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER: 'Número da conta inválido',
  IBAN_VALIDATION_INVALID_COUNTRY: 'IBAN inválido do país {0}, para o país {1}',
  IBAN_VALIDATION_INVALID_FORMAT: 'Formato IBAN inválido',
  IBAN_VALIDATION_INVALID_IBAN: 'IBAN inválido',
  IBAN_VALIDATION_NOT_FOUND: 'Nenhum banco encontrado para este IBAN',
  IBAN_VALIDATION_TOO_SHORT_4: 'Deve ter mais de 4 caracteres',
  IDENTIFIER: 'Identificador',
  IDP_LINK_ALREADY_VERIFIED: 'Se você já verificou o e-mail em outro navegador',
  IDP_LINK_CONTINUE_SUFFIX: 'para continuar.',
  IDP_LINK_EMAIL_SENT_PREFIX: 'Um e-mail com instruções para vincular a conta {0}',
  IDP_LINK_EMAIL_SENT_SUFFIX: 'à sua conta do Dashboard da Caliza foi enviado para você.',
  IDP_LINK_NOT_RECEIVED: 'Não recebeu um código de verificação no seu e-mail?',
  IDP_LINK_RESEND_SUFFIX: 'para reenviar o e-mail.',
  IDP_LINK_TITLE: 'Vincular {0}',
  IDP_LINK_USER_EXISTS: 'Já existe um usuário com o e-mail {0}. Como você quer continuar?',
  IDP_LINK_VERIFY_EMAIL: 'Você precisa verificar seu e-mail para vincular sua conta com {0}',
  'ID_#': 'ID #',
  IFSC_CODE: 'Código IFSC',
  INCOMPLETE_STATUS: 'Incompleto',
  INCORRECT_CODE: 'Código incorreto. Por favor, tente novamente',
  INCORRECT_EMAIL_PASSWORD: 'E-mail ou senha incorretos',
  INDIVIDUAL: 'Indivíduo',
  INFORMATION_FOR_PAYMENT_BENEFICIARY_OR_RECIPIENT:
    'Informações para beneficiário ou destinatário do pagamento',
  INITIATOR_AWAITING_APPROVAL_HINT:
    'Um colega de equipe revisará esta transação. Você não pode aprovar nem rejeitar sua própria transação.',
  INITIATOR_AWAITING_APPROVAL_QUOTE_HINT:
    'Um colega de equipe revisará esta transação e atualizará a cotação se ela expirar. Você não pode aprovar nem rejeitar sua própria transação.',
  INSTALL_AUTHENTICATOR_APP: 'Instale um aplicativo autenticador',
  INSTALL_AUTHENTICATOR_APP_DESCRIPTION: 'Baixe e instale um aplicativo autenticador como {0}',
  INSTANT_GLOBAL_PAYMENTS: 'Pagamentos globais instantâneos',
  INSUFFICIENT_FUNDS: 'Fundos insuficientes',
  INTEGRATOR_EARNINGS_SUBTITLE:
    'Acompanhe seus ganhos de markup, veja detalhes de transações e gerencie liquidações',
  INTERNAL_NOTES_DESCRIPTION:
    'Você pode visualizar anexos e notas em sua atividade para referência futura. Isso é apenas para seus olhos.',
  INTERNAL_NOTES_OPTIONAL: 'Notas internas (Opcional)',
  INTERNAL_TRANSFER: 'Transferência interna',
  INTERNAL_TRANSFER_ACTION: 'Transferência interna',
  INTERNAL_TRANSFER_COMPLETED: 'Transferência interna concluída',
  INTERNAL_TRANSFER_COMPLETED_DESCRIPTION:
    'Os fundos foram movidos entre suas carteiras. O saldo do destinatário será atualizado em breve.',
  INTERNAL_TRANSFER_DIRECTION: 'Direção',
  INTERNAL_TRANSFER_FROM_CUSTOMER: 'Do cliente',
  INTERNAL_TRANSFER_FROM_CUSTOMER_DESCRIPTION: 'Cliente → master',
  INTERNAL_TRANSFER_NOTES: 'Notas internas de transferência ou memorando',
  INTERNAL_TRANSFER_TO_CUSTOMER: 'Para o cliente',
  INTERNAL_TRANSFER_TO_CUSTOMER_DESCRIPTION: 'Master → cliente',
  INTERNATIONAL_PAYROLL: 'Folha de Pagamento Internacional',
  INTERNATIONAL_PAYROLL_DESC: 'Pague sua força de trabalho internacional em USDC',
  INVALID_OTP: 'Código inválido. Por favor, tente novamente.',
  INVALID_SWIFT_CODE_FOR_IBAN: 'O código Swift não corresponde ao IBAN',
  INVITATION_EXPIRED: 'Convite expirado',
  INVITATION_RESENT: 'Convite enviado novamente',
  INVITATION_REVOKED: 'Convite revogado',
  INVITATION_SENT: 'Convite enviado',
  INVITATION_SENT_SUCCESS: 'Convite enviado',
  INVITE: 'Convidar',
  INVITED_ON: 'Convidado em {0}',
  INVITE_A_TEAM_MEMBER: 'Convide um membro da equipe',
  INVITE_SOMEONE_ELSE: 'Convidar outra pessoa',
  INVITE_TO_DASHBOARD: 'Convidar para o painel',
  INVITE_TO_DASHBOARD_DESCRIPTION: '{0} receberá um e-mail com um link para criar a senha.',
  INVOICES_RECEIPTS_ETC: '(Faturas, recibos, etc)',
  IN_PROGRESS: 'Em andamento',
  IOF_WITH_PERCENTAGE: `IOF ({0})`,
  IS_POBO: 'Estou instruindo este pagamento em nome do meu cliente',
  I_AGREE_TO_THE:
    'Declaro que as informações que estou fornecendo são verdadeiras e precisas ao meu conhecimento e li e concordo com ',
  JOIN_YOUR_TEAM_ON_CALIZA: 'Junte-se à sua equipe na Caliza',
  KEEP_ACCOUNT: 'Manter conta',
  KEEP_CONTACT: 'Manter contato',
  KEEP_TWO_FACTOR_AUTHENTICATION_ENABLED: 'Manter 2FA',
  LABEL_OR_TITLE: 'rótulo',
  LANGUAGE: 'Idioma',
  LAST_NAME: 'Sobrenome',
  LAST_NAME_IS_EMPTY_ERROR: 'O sobrenome não pode estar vazio',
  LAST_SIGNED_IN_ON: 'Último acesso em {0}',
  LEADERSHIP_EXECUTIVE: 'Liderança / Executivo',
  LEARN_MORE: 'Saiba mais',
  LEAVE_ANYWAY: 'Sair mesmo assim',
  LEAVE_WITHOUT_HASH_DESC: 'Operações sem hash de transação demoram mais para serem concluídas.',
  LEGAL: 'Jurídico',
  LEGAL_ENTITY_NAME: 'Nome da entidade legal',
  LIGHT: 'Claro',
  LINK_ACCOUNT: 'Vincular conta',
  LINK_COPIED: 'Link copiado com sucesso',
  LOADING_PLEASE_WAIT: 'Carregando, por favor aguarde',
  LOADING_TRANSACTION_STATUS: 'Carregando status da transação',
  LOAD_MORE: 'Carregar mais',
  LOGIN_AND_SECURITY: 'Login e segurança',
  LOG_IN: 'Entrar',
  MAKE_A_DEPOSIT: 'Fazer um Depósito',
  MAKE_A_TRANSFER: 'Fazer uma transferência',
  MANAGE: 'Gerenciar',
  MANAGE_PAYMENT_CONTACTS: 'Gerenciar contatos de pagamento',
  MANAGE_PAYOUTS: 'Gerencie pagamentos ou receba fundos instantaneamente em stablecoins',
  MANAGE_ROLES: 'Gerenciar funções',
  MANAGE_TEAM_AND_USERS: 'Gerenciar equipe e usuários',
  MANAGE_USER: 'Gerenciar usuário',
  MANAGE_USERS: 'Gerenciar usuários',
  MANUAL_ENTRY_OPTION: 'Ou digite esta chave manualmente no seu aplicativo autenticador:',
  MARKUP: 'Margem',
  MARKUP_EARNED: 'Margem ganha',
  MASTER_ACCOUNT: 'Conta principal',
  MASTER_CALIZA_ACCOUNT: 'Conta Caliza principal ({0})',
  MAX: 'Máximo',
  MEMO_OR_DESTINATION_OPTIONAL: 'Memo ou Tag de Destino (Opcional)',
  METHOD: 'Método',
  MEXICAN_SPEI: 'Pesos mexicanos (SPEI)',
  MID_MARKET_RATE: 'Cotação de mercado',
  MID_MARKET_RATE_SOURCE: 'fonte: XE',
  MINUTES: 'minutos',
  MISSING_INTEGRATOR_INFORMATION: 'Informações do integrador ausentes, por favor complete o KYB',
  MISSING_TRADE_DOCUMENT_DETAILS:
    'Detalhes do documento comercial são obrigatórios para esta moeda',
  MOBILE_NUMBER: 'Numero de celular',
  MOBILE_WALLET_INFORMATION: 'Informações da carteira móvel',
  MOBILE_WALLET_PROVIDER: 'Provedor da carteira (opcional)',
  MONTH: 'Mês',
  MORE: '+{0} mais',
  MSISDN: 'Número de celular da carteira móvel',
  MXNB_WALLET: 'Carteira MXNB',
  MXN_DEPOSIT_DETAILS_PROVISIONING:
    'Sua conta de depósito MXN está sendo provisionada. Tente novamente em alguns minutos.',
  MYSELF: 'Eu mesmo',
  NAME: 'Nome',
  NATIONAL_ID_OPTIONAL: 'Documento de identidade (opcional)',
  NEW_CONTACT: 'Novo contato',
  NEW_DEVICE_LOGIN_DESCRIPTION: 'Logins de um novo dispositivo',
  NEW_DEVICE_LOGIN_LABEL: 'Login em novo dispositivo',
  NEW_PASSWORD: 'Nova senha',
  NEXT: 'Próximo',
  NICKNAME: 'Alias da conta',
  NICKNAME_INVALID_CHARACTERS:
    'O apelido so pode conter letras, numeros, espacos, hifens e sublinhados',
  NICKNAME_OPTIONAL: 'Alias da conta (opcional)',
  NICKNAME_PLACEHOLDER: 'Alias da conta',
  NICKNAME_REQUIRED_ERROR: 'O apelido não pode estar vazio',
  NICKNAME_UPDATED_SUCCESS: 'Apelido atualizado com sucesso',
  NINE_MIN: '9 min',
  NO: 'Não',
  NOTIFICATIONS: 'Notificações',
  NOT_APPLICABLE: 'N/A',
  NOT_AVAILABLE_FOR_PAYOUTS: 'Não disponível para pagamentos',
  NOT_STARTED: 'Não iniciado',
  NOVA_SENHA: 'Nova senha',
  NO_ACCOUNTS: 'Sem contas',
  NO_ACCOUNTS_DESCRIPTION: 'Você ainda não tem nenhuma conta de pagamento.',
  NO_ACTIVITY_YET_SUBTITLE: 'Envie ou receba fundos e eles aparecerão aqui.',
  NO_ACTIVITY_YET_TITLE: 'Nenhuma atividade ainda',
  NO_BALANCES_YET: 'Nenhum saldo disponível ainda',
  NO_BENEFICIARIES_YET_MESSAGE: 'Clientes aprovados aparecerão aqui como beneficiários.',
  NO_BENEFICIARIES_YET_TITLE: 'Nenhum beneficiário ainda',
  NO_CUSTOMERS_YET_TITLE: 'Nenhum cliente adicionado ainda',
  NO_CUSTOMER_ACTIVITY_VERIFICATION_INCOMPLETE:
    'Você não pode enviar fundos até que a verificação deste cliente seja concluída e aprovada.',
  NO_DEPOSIT_OPTIONS_AVAILABLE: 'Nenhuma opção de depósito disponível',
  NO_ILL_WAIT: 'Não, vou esperar',
  NO_ITEMS_FOUND: 'Nenhum item encontrado',
  NO_NICKNAME: 'Sem apelido de conta',
  NO_NUMBER: 'A senha deve ter pelo menos 1 número',
  NO_PAYMENT_METHODS_AVAILABLE: 'Nenhum método de pagamento disponível',
  NO_RECIPIENTS_MATCH_SEARCH: 'Nenhum destinatário corresponde à sua busca',
  NO_RECIPIENT_ACCOUNTS: 'Sem contas de destinatário',
  NO_RESULTS_FOUND: 'Nenhum resultado encontrado',
  NO_SPECIAL_CHARACTER: 'A senha deve ter pelo menos 1 caractere especial',
  NO_USD_ACCOUNTS_YET: 'Nenhuma conta USD ainda',
  NUMBER: 'número',
  N_ACCOUNTS: '{0} contas',
  ONE_TIME_PASSWORD: 'Verificar com autenticação de dois fatores',
  ONE_TIME_PASSWORD_DESCRIPTION: 'Digite o código temporário gerado no seu aplicativo autenticador',
  ONLY_CURRENCY_SUPPORTED_BY_COUNTRY: 'Apenas {0} são suportados por este país.',
  OPERATIONS: 'Operações',
  OPERATIONS_WITHOUT_A_TRANSACTION_HASH_TAKE_LONGER:
    'Operações sem um hash de transação levam mais tempo para serem concluídas.',
  OPERATOR: 'Operador',
  OPERATOR_DESCRIPTION:
    'Recursos de transação, visualizar e baixar histórico de transações e relatórios de atividades',
  OPTIONAL: 'Opcional',
  OR: 'Ou',
  ORIGINAL_TRANSACTION: 'ID# da transação original',
  OTHER: 'Outro',
  OTP_DIGIT: 'Dígito {0}',
  OUTCOME: 'Resultado',
  PASSPORT: 'Passaporte',
  PASSWORD: 'Senha',
  PASSWORDS_DO_NOT_MATCH: 'As senhas não correspondem',
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: 'A senha não atende aos requisitos',
  PASSWORD_IS_EMPTY_ERROR: 'A senha não pode estar vazia',
  PASSWORD_MINIMUM: 'A senha deve ter no mínimo',
  PAYMENT_APPROVALS: 'Aprovações de pagamentos',
  PAYMENT_APPROVAL_AWAITING_DESCRIPTION:
    'Seja notificado quando uma transferência ou saque precisa da sua aprovação, ou quando uma que você enviou está aguardando aprovação',
  PAYMENT_APPROVAL_AWAITING_LABEL: 'Aguardando aprovação',
  PAYMENT_APPROVAL_DECISION_DESCRIPTION:
    'Seja notificado quando uma transferência ou saque que você enviou for aprovado ou rejeitado',
  PAYMENT_APPROVAL_DECISION_LABEL: 'Aprovado ou rejeitado',
  PAYMENT_APPROVAL_MISCONFIG_WARNING:
    'As regras de aprovação estão ativas, mas sua organização não tem um aprovador elegível além de você. Conceda a permissão de aprovação a outro membro da equipe para que as transações possam ser aprovadas.',
  PAYMENT_APPROVAL_MISCONFIG_WARNING_NO_ACCESS:
    'As regras de aprovação estão ativas, mas sua organização não tem um aprovador elegível além de você. Peça a um administrador para conceder a permissão de aprovação a outro membro da equipe para que as transações possam ser aprovadas.',
  PAYMENT_APPROVAL_NO_APPROVER_ALERT:
    'Esta transação corresponde a uma regra de aprovação ({0}), mas sua organização não tem um aprovador elegível além de você. Um administrador precisa conceder a permissão de aprovação a outro membro da equipe ou desativar a regra.',
  PAYMENT_APPROVAL_OPERATOR_GT: 'Maior que',
  PAYMENT_APPROVAL_RULES_DESCRIPTION:
    'Retenha transferências e saques para aprovação quando uma condição for atendida.',
  PAYMENT_APPROVAL_RULES_EMPTY: 'Ainda não há regras de aprovação.',
  PAYMENT_APPROVAL_RULES_LABEL: 'Regras de aprovação de pagamentos',
  PAYMENT_APPROVAL_STATUS: 'Aprovações de pagamentos',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT: 'Valor debitado',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_CONDITION: 'Se o valor for maior que',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_DESCRIPTION:
    'O valor que sai do saldo da sua carteira Caliza quando a transação é executada, antes de qualquer conversão.',
  PAYMENT_BENEFICIARY_INFO: 'Informações para beneficiário ou destinatário do pagamento',
  PAYMENT_COMPLETED: 'Pagamento concluído',
  PAYMENT_COMPLETED_DESC: 'Seu pagamento foi concluído.',
  PAYMENT_IDENTIFIERS: 'Identificadores de Pagamento',
  PAYMENT_INSTRUCTIONS: 'Instruções de Pagamento',
  PAYMENT_METHOD: 'Método de pagamento',
  PAYMENT_METHODS: 'Métodos de pagamento',
  PAYMENT_METHODS_FETCH_ERROR: 'Ocorreu um erro ao tentar buscar os métodos de pagamento.',
  PAYMENT_METHOD_TITLE: 'Método de pagamento',
  PAYMENT_RAIL_ACH_WIRE: 'ACH e Wire',
  PAYMENT_RAIL_FEE: 'Taxa {0}',
  PAYMENT_RAIL_RTP: 'RTP',
  PAYMENT_RAIL_SWIFT: 'SWIFT',
  PAYMENT_REFERENCE: 'Referência de pagamento (máximo 35 caracteres)',
  PAYMENT_REFERENCE_DESCRIPTION:
    'Esta é uma referência de pagamento opcional para seu destinatário ver e verificar sua transferência.',
  PAYMENT_REFERENCE_DETAILS_LABEL: 'Referência de pagamento',
  PAYMENT_REFERENCE_LABEL: 'Referência de pagamento (máximo de 200 caracteres)',
  PAYMENT_SENT: 'Pagamento enviado',
  PAYMENT_SENT_DESC: 'Seu pagamento foi enviado.',
  PAYMENT_SENT_DESCRIPTION:
    'Receba notificações quando uma transferência estiver em andamento, a caminho do destinatário',
  PAYMENT_SENT_LABEL: 'Pagamento enviado',
  PAYMENT_UNDER_REVIEW: 'Pagamento em Análise',
  PAYMENT_UNDER_REVIEW_DESC: 'Seu pagamento está sendo analisado para conformidade.',
  PAYOR: 'Pagador',
  PAYOUT_SUPPORTED: 'Pagamento habilitado',
  PENDING: 'Pendente',
  PENDING_ACAM_220_FILE_ALERT: 'Ainda estamos aguardando o envio do seu arquivo ACAM 220.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTIONS_LIST_ACTION:
    'Veja os detalhes da transação para concluir.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Por favor, clique em "Detalhes" abaixo para enviar o arquivo.',
  PENDING_APPROVALS_BANNER_PLURAL: 'Você tem {0} pagamentos aguardando aprovação.',
  PENDING_APPROVALS_BANNER_SINGULAR: 'Você tem 1 pagamento aguardando aprovação.',
  PENDING_DESC: 'Seu pagamento está sendo processado',
  PERMISSIONS: 'Permissões',
  PERMISSION_SEND_PAYMENTS: 'Enviar pagamentos e converter',
  PERMISSION_SEND_PAYMENTS_HINT_OFF: 'Marque para acesso completo',
  PERMISSION_SEND_PAYMENTS_HINT_ON: 'Desmarque para acesso somente leitura',
  PERMISSION_VIEW: 'Ver saldos, atividades e destinatários',
  PERMISSION_VIEW_HINT: 'Sempre incluído',
  PERSONAL_INFORMATION: 'Informações pessoais',
  PIX: 'Pix',
  PIX_DEPOSIT_DESCRIPTION:
    'Quando estiver no seu aplicativo bancário, use o link abaixo para concluir seu depósito usando Pix. Enviaremos uma confirmação por e-mail assim que seu depósito for recebido.',
  PIX_KEY: 'Chave PIX',
  PIX_KEY_DETAILS: 'Pix key',
  PREFERRED_LANGUAGE: 'Idioma preferido',
  PREVIEW: 'Visualizar',
  PRIVACY_POLICY: 'Política de Privacidade',
  PROCEED_WITH_ACTION: 'Prosseguir com a ação',
  PROCESSED_BY_BANK: 'Processado pelo Banco',
  PROCESSED_BY_BANK_DESC: 'Seu pagamento foi processado pelo banco remetente.',
  PROCESSED_BY_INTERMEDIARY_BANK: 'Processado pelo Banco Intermediário',
  PROCESSED_BY_INTERMEDIARY_BANK_DESC: 'Seu pagamento foi processado pelo banco intermediário.',
  PROCESSING: 'Processando',
  PROCESSING_DESC: 'Seu pagamento está sendo processado.',
  PRODUCT_AND_TECHNOLOGY: 'Produto e Tecnologia',
  PRODUCT_CATEGORY_APPAREL: 'Vestuário',
  PRODUCT_CATEGORY_AUTOMOTIVE: 'Automotivo',
  PRODUCT_CATEGORY_COSMETICS: 'Cosméticos',
  PRODUCT_CATEGORY_ELECTRONICS: 'Eletrônicos',
  PRODUCT_CATEGORY_FOOD_AND_BEVERAGE: 'Alimentos e Bebidas',
  PRODUCT_CATEGORY_FURNITURE: 'Móveis',
  PRODUCT_CATEGORY_MACHINERY: 'Maquinário',
  PRODUCT_CATEGORY_OTHER: 'Outros',
  PRODUCT_CATEGORY_RAW_MATERIALS: 'Matérias-primas',
  PRODUCT_CATEGORY_TEXTILES: 'Têxteis',
  PRODUCT_CATEGORY_TOYS: 'Brinquedos',
  PROFILE: 'Perfil',
  PROVIDE_THE_SIX_DIGIT_CODE: 'Forneça o código de 6 dígitos do seu aplicativo autenticador',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION:
    'Capital próprio, transferências de financiamento',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL: 'Injeção de Capital / Investimento',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION: 'Comissões de vendas, corretagem',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL: 'Comissões e Taxas de Agentes',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_DESCRIPTION: 'ACAM220 para operação eFX',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_LABEL: 'Operação eFX',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION: 'Entre entidades relacionadas',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL: 'Transferências entre Empresas',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION: 'Bens e serviços de fornecedores',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL: 'Pagamentos de Faturas e Fornecedores',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION: 'Pagamentos de PI, software, patentes',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL: 'Licenciamento e Royalties',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION:
    'Pagamentos de empréstimos comerciais',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL: 'Pagamento de Empréstimo e Juros',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION: 'Frete, alfândega, armazenagem',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL: 'Logística e Envio',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION:
    'Anúncios digitais, campanhas, agências',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL: 'Marketing e Publicidade',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION: 'Aluguel, utilidades, seguro',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL: 'Despesas Operacionais',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION:
    'Salários, remunerações, freelancers',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL:
    'Folha de Pagamento e Pagamentos de Contratados',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION: 'Consultoria, taxas legais e contábeis',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL: 'Serviços Profissionais',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION: 'IVA, alfândega, regulatório',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL:
    'Impostos, Taxas e Encargos Governamentais',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION: 'SaaS, nuvem, infraestrutura de TI',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL: 'Serviços de Tecnologia',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION: 'Cartas de crédito, liquidações comerciais',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL: 'Financiamento Comercial',
  QR_CODE: 'Código QR',
  QR_CODE_NOT_AVAILABLE: 'Código QR não disponível',
  QUOTE_EXPIRED: 'Expirada',
  QUOTE_EXPIRED_DESCRIPTION: 'Atualize para aprovar pela taxa atual.',
  QUOTE_EXPIRED_TITLE: 'Esta cotação expirou',
  QUOTE_EXPIRES_IN: 'Expira em',
  QUOTE_ORIGINAL_MID_MARKET_RATE: 'Cotação de mercado original: {0}',
  QUOTE_ORIGINAL_VALUE: 'Originalmente {0}',
  QUOTE_REFRESH: 'Atualizar cotação',
  QUOTE_REFRESH_ERROR: 'Não foi possível atualizar a cotação. Tente novamente.',
  QUOTE_WILL_EXPIRE: 'Esta cotação expirará em',
  REACTIVATE: 'Reativar',
  REACTIVATE_BLOCKED_BY_ACTIVE_USER:
    'Desative o usuário atual do dashboard antes de restaurar este acesso.',
  REACTIVATE_BLOCKED_BY_INVITATION: 'Revogue o convite pendente antes de restaurar este acesso.',
  RECEIVED_BY_BENEFICIARY_BANK: 'Recebido pelo Banco Beneficiário',
  RECEIVED_BY_BENEFICIARY_BANK_DESC: 'Seu pagamento foi recebido pelo banco beneficiário.',
  RECEIVED_BY_INTERMEDIARY_BANK: 'Recebido pelo Banco Intermediário',
  RECEIVED_BY_INTERMEDIARY_BANK_DESC: 'Seu pagamento foi recebido pelo banco intermediário.',
  RECEIVE_AND_SEND_USD: 'Receba e envie USD usando seu próprio número de conta e roteamento',
  RECIPIENT: 'Destinatário',
  RECIPIENTS: 'Destinatários',
  RECIPIENTS_WALLET: 'Endereço da carteira do destinatário',
  RECIPIENT_ADDRESS: 'Endereço do destinatário',
  RECIPIENT_DETAILS: 'Detalhes do destinatário',
  RECIPIENT_EMAIL: 'E-mail do destinatário',
  RECIPIENT_GETS: 'Destinatário recebe',
  RECIPIENT_ID: 'ID do destinatário',
  RECIPIENT_ID_TYPE: 'Tipo de ID do Destinatário',
  RECIPIENT_INFORMATION: 'Informações do destinatário',
  RECIPIENT_MEMO: 'Memo do destinatário',
  RECIPIENT_MEMO_OPTIONAL: 'Memo do destinatário (Opcional)',
  RECIPIENT_NOT_FOUND: 'Destinatário não encontrado',
  RECIPIENT_TYPE: 'Tipo de destinatário',
  REFERENCE: 'Referência',
  REFUND: 'Reembolso',
  REFUNDED: 'Reembolsada',
  REFUNDED_ALERT: 'Esta transação foi reembolsada.',
  REFUNDED_ALERT_ACTION: 'Veja a transação de reembolso nos detalhes.',
  REFUNDED_DESC: 'Sua transação foi reembolsada.',
  REFUND_TO: 'Reembolso para {0}',
  REFUND_TRANSACTION: 'ID# da transação de reembolso',
  REGISTRATION_NUMBER: 'Número de registro',
  REJECT: 'Rejeitar',
  REJECTED: 'Rejeitada',
  REJECTED_DESC: 'Sua transação foi rejeitada.',
  REMOVE: 'Remover',
  REMOVE_USERS_BUTTON_LABEL: 'Remover {0}',
  REQUIRED_ACCOUNT: 'Selecione a conta para continuar',
  REQUIRED_AMOUNT: 'O valor não pode estar vazio',
  REQUIRED_FUNDING_METHOD: 'Selecione o método de financiamento para continuar',
  REQUIRED_RECIPIENT: 'O destinatário não pode estar vazio',
  REQUIRED_SUPPORTING_DOCUMENTATION: 'Documentação de suporte é obrigatória',
  RESEND: 'Reenviar',
  RESEND_CODE: 'Reenviar código',
  RESEND_INVITE: 'Reenviar convite',
  RESEND_INVITE_ERROR: 'Erro ao reenviar o convite',
  RESEND_INVITE_SUCCESS: 'Convite reenviado com sucesso',
  RESET: 'Redefinir',
  RESETTING: 'Redefinindo...',
  RESET_PASSWORD: 'Redefinir senha',
  RESET_PASSWORD_DESCRIPTION: 'Digite sua senha atual para redefini-la',
  RESET_PASSWORD_FAILED: 'Falha ao redefinir senha. Por favor, tente novamente.',
  RESET_PASSWORD_FORBIDDEN: 'Por favor, forneça sua senha atual para redefini-la.',
  RESET_PASSWORD_SUCCESS: 'Senha redefinida com sucesso',
  RESET_PASSWORD_TITLE: 'Redefinir senha',
  RESULT: 'Resultado',
  RESUME_VERIFICATION: 'Retomar verificação',
  RETRY: 'Tentar novamente',
  RETURNED: 'Devolvida',
  RETURNED_DESC: 'Sua transação foi devolvida.',
  REVEAL: 'Mostrar',
  REVENUE_EARNINGS: 'Receita de comissões',
  REVERSAL: 'Estorno',
  REVERSAL_TRANSACTION: 'ID# da transação de estorno',
  REVERSED: 'Estornada',
  REVERSED_ALERT: 'Este depósito foi estornado.',
  REVERSED_ALERT_ACTION: 'Veja a transação de estorno nos detalhes.',
  REVERSED_DESC: 'Seu depósito foi estornado.',
  REVIEW: 'Revisão',
  REVIEW_AND_SUBMIT: 'Revisar e enviar',
  REVIEW_CONVERSION: 'Revisar conversão',
  REVIEW_PROFILE: 'Revisar perfil',
  REVIEW_STATUS_APPROVED: 'Aprovado',
  REVIEW_STATUS_PENDING_REVIEW: 'Revisão pendente',
  REVIEW_STATUS_REJECTED: 'Rejeitado',
  REVOKE: 'Revogar',
  REVOKE_INVITE: 'Revogar convite',
  REVOKE_INVITE_DESCRIPTION:
    'O convite enviado para {0} deixará de funcionar. Você pode enviar um novo convite a qualquer momento.',
  REVOKE_INVITE_TITLE: 'Revogar este convite?',
  RISK_AND_COMPLIANCE: 'Risco e Conformidade',
  ROLE: 'Cargo',
  ROLE_APPROVE_OR_REJECT_TRANSACTION: 'Aprovar ou rejeitar transações',
  ROLE_CREATE_TRANSACTIONS: 'Criar transações',
  ROLE_CREATE_USD_ACCOUNT: 'Criar contas USD',
  ROLE_MANAGE_CUSTOMER: 'Gerenciar clientes',
  ROLE_MANAGE_PAYMENT_APPROVAL_RULES: 'Gerenciar regras de aprovação de pagamentos',
  ROLE_MANAGE_PAYMENT_CONTACTS: 'Gerenciar contatos de pagamento',
  ROLE_MANAGE_USER: 'Gerenciar time e usuários',
  ROLE_NAME: 'Nome do cargo',
  ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS: 'Receber notificações de status de transações',
  ROLE_VIEW_ACTIVITY: 'Visualizar e baixar histórico de transações e relatório de atividade',
  ROLE_VIEW_BENEFICIARIES: 'Visualizar contas',
  ROLE_VIEW_INTEGRATOR_EARNINGS: 'Visualizar ganhos',
  ROLE_VIEW_USD_ACCOUNT: 'Visualizar contas USD',
  ROLE_WITHDRAW_INTEGRATOR_EARNINGS: 'Sacar ganhos',
  ROTATE: 'Rotacionar',
  ROTATE_WEBHOOK_SECRET: 'Rotacionar segredo de webhook',
  ROTATE_WEBHOOK_SECRET_CONFIRM_DESCRIPTION:
    'Um novo segredo de webhook será gerado. Seu segredo antigo deixará de funcionar imediatamente e qualquer integração que dependa dele falhará até que você o atualize.',
  ROTATE_WEBHOOK_SECRET_CONFIRM_TITLE: 'Rotacionar segredo de webhook?',
  ROUTING_CODE_CAD: 'Número de trânsito + instituição',
  ROUTING_NUMBER: 'Número de roteamento',
  ROUTING_NUMBER_COPIED: 'Número de roteamento copiado com sucesso',
  ROUTING_NUMBER_DETAILS: 'Número de roteamento',
  ROUTING_NUMBER_WITH_CURRENCY: 'Número de roteamento ({0})',
  RTP: 'RTP',
  RUNNING: 'Em execução',
  SALES: 'Vendas',
  SAME_DAY_ACH: 'ACH no mesmo dia',
  SAMPLE_RESPONSES: 'Respostas de amostra',
  SAVE: 'Salvar',
  SAVE_AND_CLOSE: 'Salvar e fechar',
  SAVE_CHANGES: 'Salvar alterações',
  SAVINGS: 'Poupança',
  SCAN_QR_CODE: 'Escaneie o código QR',
  SEARCH: 'Pesquisar',
  SEARCH_BY_CURRENCY_OR_RAIL: 'Pesquisar por moeda ou trilho',
  SEARCH_BY_NAME: 'Pesquisar por nome',
  SEARCH_COUNTRIES: 'Pesquisar países',
  SEARCH_RECIPIENTS_PLACEHOLDER: 'Pesquise por nome, apelido, banco ou conta',
  SECURE_AND_COMPLIANT: 'Rampas criptográficas seguras e compatíveis',
  SEE_ACCOUNTS: 'Ver contas',
  SEE_ALL: 'Ver tudo',
  SEE_DETAILS: 'Ver detalhes',
  SELECT_ACCOUNT: 'Selecionar conta',
  SELECT_ALL: 'Marcar todos',
  SELECT_CONTACT_TYPE: 'Selecione o tipo de contato',
  SELECT_CUSTOMER: 'Selecionar cliente',
  SELECT_EXISTING_CONTACT: 'Selecionar contato existente',
  SELECT_FILTERS_THAT_APPLY:
    'Selecione qualquer um dos seguintes filtros para aplicar à sua pesquisa',
  SELECT_FUNDING_CURRENCY: 'Selecione a moeda de financiamento',
  SELECT_PAYMENT_METHOD: 'Selecione um método de pagamento',
  SELECT_PURPOSE_FOR_TRANSFER: 'Selecione o propósito da transferência',
  SELECT_RECIPIENT: 'Selecione destinatário',
  SELECT_RECIPIENT_ACCOUNT: 'Selecione os detalhes da conta do destinatário',
  SELECT_RECIPIENT_ACCOUNT_DETAILS: 'Selecione os detalhes da conta do destinatário',
  SELECT_ROLE_FUNCTIONS: 'Selecione quais funções este cargo tem:',
  SELECT_TARGET_CURRENCY: 'Moeda destino',
  SELECT_TYPE: 'Selecionar tipo',
  SELECT_WAYS_TO_USE_CALIZA: 'Selecione as maneiras que você planeja usar a Caliza',
  SELF_APPROVAL_HINT: 'Você não pode aprovar nem rejeitar seu próprio pagamento.',
  SENDER: 'Remetente',
  SENDER_INFORMATION: 'Informações do Remetente',
  SENDER_NAME_NO_USD_DETAILS:
    'Este cliente não possui dados de conta USD, então o seu nome aparecerá neste pagamento.',
  SENDER_NAME_SHOWN_TO_RECIPIENT: 'Nome do remetente visível para o destinatário',
  SEND_FUNDS_FROM_BANK: 'Envie fundos do seu banco para concluir a transferência',
  SEND_FUNDS_TO_CALIZA_WALLET: 'Envie fundos para sua conta Caliza',
  SEND_FUNDS_TO_COMPLETE_TRANSFER: 'Envie fundos para concluir a transferência',
  SEND_INVITATION: 'Enviar convite',
  SEND_TO_RECIPIENT: 'Enviar para destinatário',
  SENHA_ATUAL: 'Senha atual',
  SETTINGS: 'Configurações',
  SETTINGS_UPDATE_ERROR: 'Falha ao atualizar configurações. Por favor, tente novamente.',
  SETTINGS_UPDATE_SUCCESS: 'Configurações atualizadas com sucesso',
  SETTLEMENT_CURRENCY: 'Moeda de liquidação',
  SETTLEMENT_INSTANT: 'Instantâneo',
  SETTLEMENT_INSTANT_MARKET_HOURS: 'Instantâneo (durante horário do mercado)',
  SETTLEMENT_ONE_TO_THREE_DAYS: '1-3 dias úteis',
  SETTLEMENT_ONE_TO_TWO_DAYS: '1-2 dias úteis',
  SETTLEMENT_SAME_DAY_BEFORE_CUTOFF: 'Mesmo dia (se enviado antes do horário de corte)',
  SETTLEMENT_TIME: 'Tempo de liquidação',
  SETTLEMENT_UNKNOWN: 'Tempo de liquidação indisponível',
  SETTLEMENT_WITHIN_15_MINUTES: 'Normalmente dentro de 15 minutos',
  SETTLEMENT_WITHIN_5_MINUTES: 'Normalmente dentro de 5 minutos',
  SETUP_AUTHENTICATOR: 'Configure seu autenticador',
  SET_NEW_PASSWORD: 'Definir nova senha',
  SET_YOUR_PASSWORD: 'Crie sua senha',
  SET_YOUR_PASSWORD_DESCRIPTION:
    'Sua conta está pronta. Escolha uma senha para acessar seu painel.',
  SHARE_TRANSACTION_HASH: 'Compartilhar hash da transação',
  SHOW_LESS: 'Mostrar menos',
  SHOW_MORE: 'Mostrar mais',
  SHOW_PASSWORD: 'Mostrar senha',
  SHOW_ROLE_DETAILS: 'Mostrar detalhes do cargo',
  SIGN_IN: 'Entrar',
  SIGN_OUT: 'Sair',
  SIGN_UP: 'Cadastrar-se',
  SIGN_UP_WITH_GOOGLE: 'Inscrever-se com Google',
  SIX_DIGIT_AUTHENTICATOR_CODE: 'Código do autenticador de 6 dígitos',
  SKIP_TWO_FACTOR_VERIFICATION: 'Pular verificação de dois fatores',
  SPECIAL_CHARACTER: 'caractere especial',
  SPEI_BANK_BENEFICIARY: 'Beneficiário',
  SPEI_BANK_NAME: 'Banco',
  SPEI_CLABE_COPIED: 'CLABE copiado.',
  SPEI_DEPOSIT_DESCRIPTION: 'Use essa chave CLABE para realizar seu depósito.',
  STABLECOIN_BALANCES: 'Saldos da conta do cliente',
  STABLECOIN_WALLET: 'Carteira de stablecoin',
  START_CURRENCY: 'Moeda inicial',
  START_VERIFICATION: 'Iniciar verificação',
  STATE: 'Estado',
  STATEMENT_DISCLAIMER: 'Os extratos de conta são gerados e fornecidos pela Caliza.',
  STATEMENT_FORMAT: 'Formato',
  STATEMENT_FORMAT_CSV: 'Planilha CSV (Excel)',
  STATEMENT_FORMAT_PDF: 'Documento PDF',
  STATEMENT_MENU_ITEM: 'Extratos',
  STATEMENT_PERIOD_ERROR: 'Selecione um período válido de até um ano',
  STATUS: 'Status',
  STEP: 'Passo',
  STREET_ADDRESS: 'Endereço',
  SUBMIT: 'Enviar',
  SUBMITTED: 'Enviado',
  SUCCEEDED: 'Concluída',
  SUCCEEDED_DESC: 'Sua transação foi concluída.',
  SUITE_FLOOR_APT: 'Complemento',
  SUMMARY: 'Resumo',
  SUPPORTED_ONLY: 'Apenas suportados',
  SUPPORTING_DOCUMENTATION: 'Documentação de suporte',
  SUPPORTING_DOCUMENTATION_DESCRIPTION:
    'Por motivos de conformidade, este pagamento requer um documento de suporte, como uma fatura, contrato ou holerite. Isso não será enviado ao seu destinatário.',
  SWIFT: 'SWIFT',
  SWIFT_CODE: 'Código SWIFT',
  SWIFT_CODE_DETAILS: 'Código Swift',
  SWIFT_CODE_INVALID:
    'O código SWIFT deve ter 6 letras seguidas de 2 ou 5 caracteres alfanuméricos',
  SWIFT_CODE_NOT_FOUND: 'Nenhum banco encontrado para este código SWIFT',
  SWIFT_CURRENCY_INSTRUCTED_VERSUS_SETTLEMENT_TOOLTIP:
    'Os fundos são transferidos em {0}. A moeda de liquidação depende do banco e da conta do destinatário.',
  SWIFT_MINIMUM_AMOUNT: 'O valor mínimo para transferência SWIFT é 15000 USD',
  SWIFT_TO_WIRE_MORPH_NEEDS_ROUTING:
    'Pagamentos para bancos dos EUA são enviados como transferências domésticas (wire). Informe o número de roteamento (ABA) e o número da conta indicados pelo seu banco.',
  SWIFT_TO_WIRE_MORPH_PREFILLED:
    'Pagamentos para bancos dos EUA são enviados como transferências domésticas (wire). Preenchemos o número de roteamento (ABA) a partir do código SWIFT do seu banco — confirme e informe o número da conta.',
  SWIFT_UPDATED_BADGE: 'Atualizado por IBAN',
  SYSTEM_ERROR: 'Algo deu errado. Tente novamente.',
  TAX: 'Imposto ({0})',
  TEN_MIN: '10 min',
  TERMS_ACCEPT_ERROR: 'Você deve aceitar os Termos de Serviço e a Política de Privacidade',
  TERMS_OF_SERVICE: 'Termos de Serviço',
  THEME: 'Tema',
  THESE_USERS: 'estes usuários',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'Esta ação não é reversível.',
  THIS_MONTH: 'Este mês',
  THIS_QUOTE_WILL_REMAIN_ACTIVE_FOR: 'Esta cotação permanecerá ativa por',
  THIS_USER: 'este usuário',
  THIS_WEEK: 'Esta semana',
  TIMEZONE_ALASKA_STANDARD_TIME: 'Horário Padrão do Alasca - AKST',
  TIMEZONE_ARGENTINA_TIME: 'Horário da Argentina - ART',
  TIMEZONE_BOLIVIA_TIME: 'Horário da Bolívia - BOT',
  TIMEZONE_BRAZIL_TIME: 'Horário de Brasília - BRT',
  TIMEZONE_CENTRAL_EUROPEAN_TIME: 'Horário Central Europeu - CET',
  TIMEZONE_CENTRAL_STANDARD_TIME: 'Horário Padrão Central - CST',
  TIMEZONE_CHILE_TIME: 'Horário Padrão do Chile - CLT',
  TIMEZONE_COLOMBIA_TIME: 'Horário da Colômbia - COT',
  TIMEZONE_EASTERN_EUROPEAN_TIME: 'Horário Oriental Europeu - EET',
  TIMEZONE_EASTERN_STANDARD_TIME: 'Horário Padrão Oriental - EST',
  TIMEZONE_ECUADOR_TIME: 'Horário do Equador - ECT',
  TIMEZONE_GREENWICH_MEAN_TIME: 'Horário Médio de Greenwich - GMT',
  TIMEZONE_GUYANA_TIME: 'Horário da Guiana - GYT',
  TIMEZONE_HAWAII_STANDARD_TIME: 'Horário Padrão do Havaí - HST',
  TIMEZONE_MOSCOW_TIME: 'Horário de Moscou - MSK',
  TIMEZONE_MOUNTAIN_STANDARD_TIME: 'Horário Padrão da Montanha - MST',
  TIMEZONE_PACIFIC_STANDARD_TIME: 'Horário Padrão do Pacífico - PST',
  TIMEZONE_PARAGUAY_TIME: 'Horário do Paraguai - PYT',
  TIMEZONE_PERU_TIME: 'Horário do Peru - PET',
  TIMEZONE_SURINAME_TIME: 'Horário do Suriname - SRT',
  TIMEZONE_URUGUAY_TIME: 'Horário do Uruguai - UYT',
  TIMEZONE_VENEZUELA_TIME: 'Horário da Venezuela - VET',
  TIMEZONE_WESTERN_EUROPEAN_TIME: 'Horário Ocidental Europeu - WET',
  TIME_ZONE: 'Fuso horário',
  TO: 'Para',
  TODAY: 'Hoje',
  TOO_SHORT: 'Senha muito curta, deve ter no mínimo 8 caracteres',
  TOTAL_ACROSS_N_ACCOUNTS: 'Total em {0} contas',
  TOTAL_AMOUNT: 'Valor total',
  TOTAL_EARNINGS: 'Ganhos totais (histórico)',
  TOTAL_FEES: 'Total de taxas',
  TOTAL_USD_BALANCE: 'Saldo total em USD',
  TOTP_APP_FREEOTP_NAME: 'FreeOTP',
  TOTP_APP_GOOGLE_NAME: 'Google Authenticator',
  TOTP_APP_MICROSOFT_AUTHENTICATOR_NAME: 'Microsoft Authenticator',
  TOTP_DISABLED_ERROR: 'Ocorreu um erro ao desabilitar a autenticação de dois fatores',
  TOTP_DISABLED_SUCCESS: 'Autenticação de dois fatores desabilitada com sucesso',
  TOTP_ENABLED_FAILED: 'Ocorreu um erro ao habilitar a autenticação de dois fatores',
  TOTP_ENABLED_SUCCESSFULLY: 'Autenticação de dois fatores habilitada com sucesso',
  TOTP_STEP_1: 'Abra um aplicativo autenticador como Google Authenticator',
  TOTP_STEP_2: 'Escaneie o código QR usando o aplicativo autenticador',
  TOTP_STEP_3: 'Digite o código temporário gerado com seu aplicativo autenticador',
  TO_DATE: 'Até (MM/AA)',
  TO_DATE_CANNOT_BE_AFTER_TODAY: 'A data final não pode ser posterior à data de hoje',
  TO_DATE_MUST_BE_AFTER_FROM_DATE: 'A data final deve ser posterior à data inicial',
  TRADE_DOCUMENT_ADD_PRODUCT: 'Adicionar produto',
  TRADE_DOCUMENT_CUSTOMS_DECLARATION_NO: 'Número da declaração aduaneira',
  TRADE_DOCUMENT_DETAILS_TITLE: 'Detalhes do documento comercial',
  TRADE_DOCUMENT_LOGISTICS_COMPANY: 'Empresa de logística',
  TRADE_DOCUMENT_LOGISTICS_ORDER_NO: 'Número do pedido de logística',
  TRADE_DOCUMENT_PRODUCTS_TITLE: 'Produtos',
  TRADE_DOCUMENT_PRODUCT_CATEGORY: 'Categoria do produto',
  TRADE_DOCUMENT_PRODUCT_NAME: 'Nome do produto',
  TRADE_DOCUMENT_QUANTITY: 'Quantidade',
  TRADE_DOCUMENT_REMOVE_PRODUCT: 'Remover produto',
  TRADE_DOCUMENT_SHIP_DATE: 'Data de envio (opcional)',
  TRANSACTIONS_CSV_MENU_ITEM: 'Transações (CSV)',
  TRANSACTION_ACH_EFFECTIVE_DATE: 'Data efetiva',
  TRANSACTION_ACH_SEC_CODE: 'Código SEC',
  TRANSACTION_ACH_TRACE_NUMBER: 'Número de rastreamento ACH',
  TRANSACTION_APPROVAL_ERROR: 'Não foi possível enviar a decisão. Tente novamente.',
  TRANSACTION_APPROVED_SUCCESS: 'Transação aprovada',
  TRANSACTION_CONFIRMATION: 'Confirmação de transação',
  TRANSACTION_DETAILS: 'Detalhes da transação',
  TRANSACTION_DETAILS_TITLE: 'Detalhes da transação',
  TRANSACTION_HASH: 'Hash da transação',
  TRANSACTION_ID: 'ID da transação#',
  TRANSACTION_IMAD: 'IMAD',
  TRANSACTION_NOT_AWAITING_APPROVAL_ERROR: 'Esta transação não está mais aguardando aprovação.',
  TRANSACTION_NOT_FOUND: 'Transação não encontrada',
  TRANSACTION_OMAD: 'OMAD',
  TRANSACTION_PACS008: 'PACS008',
  TRANSACTION_REJECTED_SUCCESS: 'Transação rejeitada',
  TRANSACTION_TYPE: 'Tipo de transação',
  TRANSACTION_UETR: 'UETR',
  TRANSFER: 'Transferência',
  TRANSFER_ACTION: 'Transferir',
  TRANSFER_CREATED_DESCRIPTION: 'Receba notificações quando uma transferência for criada',
  TRANSFER_CREATED_LABEL: 'Criada',
  TRANSFER_FEES_FREE: 'Taxas de transferência (Grátis)',
  TRANSFER_FEES_WITH_PERCENTAGE: 'Taxas de transferência ({0})',
  TRANSFER_FUNDS: 'Transferir fundos',
  TRANSFER_RECEIVED: 'Recebemos seu pagamento e iniciamos sua transferência',
  TRANSFER_STATUS: 'Status da transferência',
  TRANSFER_TO: 'Transferência para {0}',
  TRAVEL_RULE_BENEFICIARY_VASP: 'VASP do beneficiário',
  TRAVEL_RULE_COLLECTION_INCOMPLETE:
    'A conexão com a carteira terminou sem uma assinatura verificada. Tente novamente.',
  TRAVEL_RULE_COLLECTION_TIMEOUT: 'A verificação não foi concluída a tempo. Tente novamente.',
  TRAVEL_RULE_POPUP_BLOCKED:
    'Seu navegador bloqueou a janela de verificação. Permita pop-ups para este site e tente novamente.',
  TRAVEL_RULE_PROOF_REQUIRED: 'Verificação de posse da carteira necessária',
  TRAVEL_RULE_PROOF_REQUIRED_FIRST_PARTY_INFO:
    'Regulações exigem uma comprovação única de que você é o titular desta carteira auto-hospedada antes de enviar fundos para ela. Conecte a carteira e assine uma mensagem — leva um minuto e não custa nada.',
  TRAVEL_RULE_PROOF_REQUIRED_THIRD_PARTY_INFO:
    'Regulações exigem que o titular desta carteira auto-hospedada comprove a posse do endereço antes que você possa enviar fundos para ela. Inicie uma transferência de teste e compartilhe as instruções com o dono da carteira.',
  TRAVEL_RULE_SIGN_INSTEAD: 'Prefere assinar? Verifique com a assinatura da carteira',
  TRAVEL_RULE_START_TEST: 'Verificar com uma transferência de teste',
  TRAVEL_RULE_STATUS_CHECK_FAILED:
    'Não foi possível consultar o status de verificação da carteira. Tente novamente.',
  TRAVEL_RULE_TEST_AMOUNT: 'Valor exato ({0})',
  TRAVEL_RULE_TEST_AUTO_VERIFY:
    'A verificação é automática assim que o depósito chegar. Quando o valor do teste aparecer creditado no seu saldo, atualize o status aqui.',
  TRAVEL_RULE_TEST_CREDITED:
    'O valor do teste é creditado no saldo da sua conta assim que recebido.',
  TRAVEL_RULE_TEST_DESTINATION: 'Endereço de destino',
  TRAVEL_RULE_TEST_FROM_WALLET:
    'A transferência deve partir da carteira em verificação ({0}), na rede {1} — transferências de exchanges ou de qualquer outro endereço não serão reconhecidas.',
  TRAVEL_RULE_TEST_INSTRUCTIONS:
    'Para comprovar a posse, envie o valor exato abaixo para o endereço de destino antes de {0}.',
  TRAVEL_RULE_TEST_PENDING: 'Transferência de teste pendente',
  TRAVEL_RULE_TEST_REFRESH: 'Atualizar status',
  TRAVEL_RULE_TEST_SHARE:
    'Compartilhe estas instruções com o dono da carteira — só ele pode enviar a partir dela.',
  TRAVEL_RULE_VASP_DID: 'DID do VASP',
  TRAVEL_RULE_VASP_DID_COPIED: 'DID do VASP copiado com sucesso',
  TRAVEL_RULE_VERIFY_NOW: 'Verificar com assinatura da carteira',
  TREASURY_MANAGEMENT: 'Gestão de Tesouraria',
  TREASURY_MANAGEMENT_DESC: 'Otimize operações de tesouraria internacional e saldos de caixa',
  TRY_CHANGING_YOUR_APPLIED_FILTERS: 'Tente alterar seus filtros aplicados para ver mais {0}.',
  TWELVE_CHARACTERS: 'doze caracteres',
  TWO_FACTOR_AUTHENTICATION: 'Escaneie o QR para obter o código',
  TWO_FACTOR_AUTHENTICATION_DESCRIPTION:
    'Incentivamos você a configurar um aplicativo autenticador para melhor proteger sua conta',
  TWO_FACTOR_AUTHENTICATION_SECTION_DESCRIPTION:
    'Evite acesso não autorizado à sua conta Caliza configurando a autenticação de dois fatores com um aplicativo autenticador',
  TWO_FACTOR_AUTHENTICATION_SECTION_LABEL: 'Autenticação de dois fatores',
  TWO_FACTOR_RESET_ERROR: 'Falha ao redefinir a autenticação de dois fatores. Tente novamente.',
  TWO_FACTOR_RESET_SUCCESS:
    'A autenticação de dois fatores foi redefinida com sucesso. Você será desconectado em breve.',
  TYPE: 'Tipo',
  UNKNOWN: 'Desconhecido',
  UNKNOWN_ERROR: 'Erro desconhecido',
  UNSET: '(Não definido)',
  UPDATE: 'Atualizar',
  UPDATE_ACCOUNT_INFORMATION: 'Atualizar informações da conta',
  UPDATE_CONTACT_SUCCESS: 'Contato atualizado com sucesso',
  UPDATE_EMAIL_ADDRESS_DESCRIPTION:
    'Confirmação quando você atualizar seu endereço de e-mail para sua conta',
  UPDATE_EMAIL_ADDRESS_LABEL: 'Endereço de e-mail atualizado',
  UPDATE_PAYMENT_METHOD_SUCCESS: 'Método de pagamento atualizado com sucesso',
  UPLOAD_DOCUMENT: 'Carregar documento',
  UPLOAD_DOCUMENTS_NOT_ALLOWED: 'Esta transação não pode mais aceitar documentos.',
  UPLOAD_ERROR_MESSAGE: 'Erro ao carregar o arquivo. Por favor, tente novamente.',
  UPLOAD_FILE_TOO_LARGE: 'Cada arquivo deve ter 10 MB ou menos.',
  UPLOAD_SUCCESS_MESSAGE: 'Arquivo carregado com sucesso',
  USDC_AND_USDT: 'Rampas de entrada e saída de USDC e USDT para empresas de todos os tamanhos',
  USDC_LABEL: 'USDC',
  USDC_WALLET: 'Carteira USDC',
  USDT_WALLET: 'Carteira USDT',
  USD_ACCOUNT: 'Conta USD',
  USD_ACCOUNTS: 'Detalhes da conta USD',
  USD_ACCOUNT_BENEFIT_1: 'Receba USD via ACH, Wire, RTP ou SWIFT com dados de conta exclusivos',
  USD_ACCOUNT_BENEFIT_2: 'Faça pagamentos nomeados em nome do seu cliente',
  USD_ACCOUNT_BENEFIT_3: 'Mantenha saldos em USD sem necessidade de conversão',
  USD_ACCOUNT_CERT_AUTHORITY:
    'Certifico que {0} está devidamente autorizada pela Caliza Financial Technologies, Inc. para abrir e gerenciar esta Conta Virtual USD da Caliza, incluindo quaisquer consentimentos, aprovações e autorizações regulatórias necessárias (quando aplicável).',
  USD_ACCOUNT_CERT_AUTHORITY_LABEL: 'Autoridade',
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE:
    'Certifico que esta conta será usada apenas para transações e fundos da Caliza Financial Technologies, Inc., e não para terceiros ou atividades não relacionadas (incluindo mistura de fundos).',
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE_LABEL: 'Uso exclusivo do cliente',
  USD_ACCOUNT_CERT_LAWFUL_USE:
    'Certifico que os fundos são lícitos e conhecidos, esta conta será usada apenas para atividades permitidas pela Caliza, e nenhum fundo ou atividade envolve pessoas ou entidades ilícitas ou sancionadas, conforme a {0} da Caliza.',
  USD_ACCOUNT_CERT_LAWFUL_USE_LABEL: 'Uso Autorizado e Legal',
  USD_ACCOUNT_CERT_LAWFUL_USE_LINK: 'Política de PLD',
  USD_ACCOUNT_CERT_TERMS:
    'Certifico que li os {0} e a {1} da Caliza na íntegra e concordo em cumpri-los.',
  USD_ACCOUNT_CERT_TERMS_LABEL: 'Termos e Condições',
  USD_ACCOUNT_CERT_TERMS_LINK: 'Termos e Condições',
  USD_ACCOUNT_CERT_TERMS_PRIVACY_LINK: 'Política de Privacidade',
  USD_ACCOUNT_CREATION_ERROR: 'Ocorreu um erro ao criar sua conta. Por favor, tente novamente.',
  USD_ACCOUNT_CREATION_TIMEOUT:
    'A criação da conta está demorando mais do que o esperado. Por favor, feche este diálogo e verifique novamente em alguns momentos.',
  USD_ACCOUNT_DESCRIPTION:
    'Use estes dados para receber transferências em USD. Os fundos serão creditados no saldo da conta.',
  USD_ACCOUNT_TERMS_DESCRIPTION:
    'Por favor, revise e aceite as seguintes certificações para criar a conta USD.',
  USD_BALANCE: 'Saldo USD',
  USD_BALANCE_HEADLINE: 'Mantenha e pague em USD',
  USD_BALANCE_HELPER:
    'Financie a partir de trilhos locais ou stablecoins. Envie pagamentos USD sob o nome da Caliza.',
  USD_BALANCE_SUBTITLE: 'Mantenha e transfira USD',
  USD_BANNER_DESCRIPTION:
    'Mantenha USD e envie pagamentos por padrão. Adicione contas USD para depósitos ACH/Wire/SWIFT, pagamentos nomeados e conciliação.',
  USD_BANNER_TITLE: 'Novo: Os saldos USD agora funcionam sem uma conta USD.',
  USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY: 'USD (ACH e Wires)',
  USER: 'usuário',
  USERS: 'usuários',
  USE_CUSTOMER_BALANCE: 'Use o saldo do cliente',
  USE_KEY: 'Usar chave',
  USE_YOUR_CALIZA_BALANCE: 'Use seu saldo Caliza',
  US_DOLLAR: 'Dólar Americano',
  VALIDATION_ACTIVE_USER_CONFLICT: 'Este endereço de e-mail já está vinculado a um usuário ativo',
  VALIDATION_CNAPS_CODE_INVALID: 'O código CNAPS deve ter exatamente 12 dígitos',
  VALIDATION_CVU_INVALID: 'CVU ou CBU deve ter exatamente 22 dígitos',
  VALIDATION_IFSC_CODE_INVALID:
    'O código IFSC deve ter 4 letras, um 0 e 6 caracteres alfanuméricos',
  VALIDATION_INVALID_SWIFT_CHARACTERS:
    'O código SWIFT deve conter apenas letras maiúsculas e números',
  VALIDATION_MSISDN_INVALID:
    'O número de telefone deve estar em formato internacional, ex. +254712345678',
  VALIDATION_PASSWORD_MIN_12: 'A senha deve ter no mínimo 12 caracteres',
  VALIDATION_PASSWORD_NUMBER: 'A senha deve ter no mínimo 1 número',
  VALIDATION_PASSWORD_SPECIAL_CHARACTER: 'A senha deve ter no mínimo 1 caractere especial',
  VALIDATION_REQUIRED: '{0} é obrigatório',
  VALIDATION_ROUTING_CODE_INVALID: 'O código de roteamento deve ter 8 ou 9 dígitos',
  VALIDATION_SWIFT_BIC_COUNTRY_MISMATCH:
    'O país do código SWIFT/BIC não corresponde ao país de destino selecionado. Verifique o código SWIFT ou altere o país.',
  VALIDATION_TOO_LONG_16: '{0} deve ter menos de 16 caracteres',
  VALIDATION_TOO_LONG_20: '{0} deve ter menos de 20 caracteres',
  VALIDATION_TOO_LONG_70: '{0} deve ter menos de 70 caracteres',
  VALIDATION_USER_CONFLICT:
    'Um convite já foi enviado para este e-mail para se juntar à sua equipe',
  VALUE: 'Valor',
  VARIABLE: 'Variável',
  VA_ACCOUNTS_DESCRIPTION:
    'Crie contas dedicadas com números de conta únicos para ACH, Wires, RTP e SWIFT.',
  VA_ACCOUNTS_HEADLINE: 'Receba e envie USD em seu nome',
  VA_BENEFIT_DEDICATED_DESC: 'Números de conta únicos atribuídos exclusivamente a este cliente',
  VA_BENEFIT_DEDICATED_TITLE: 'Contas dedicadas',
  VA_BENEFIT_MULTIPLE_DESC:
    'Crie múltiplas contas para diferentes propósitos ou unidades de negócio',
  VA_BENEFIT_MULTIPLE_TITLE: 'Múltiplas contas',
  VA_BENEFIT_RAILS_DESC: 'Receba depósitos por todas as principais vias de pagamento dos EUA',
  VA_BENEFIT_RAILS_TITLE: 'ACH, Wire, SWIFT',
  VA_DEPOSITS_FOOTER: 'Depósitos nestas contas são refletidos no seu saldo USD acima.',
  VA_SECTION_SUBTITLE: 'Crie múltiplas contas dedicadas para receber e enviar USD em seu nome.',
  VERIFICATION_STATUS: 'Status da verificação',
  VERIFY: 'Verificar',
  VERIFY_BUSINESS_ADDRESS: 'Endereço',
  VERIFY_BUSINESS_ADDRESS_LABEL: 'Endereço',
  VERIFY_BUSINESS_ADD_ANOTHER_OWNER: 'Adicionar outro proprietário',
  VERIFY_BUSINESS_ADD_SOCIAL_MEDIA: 'Adicionar outro canal de mídia social',
  VERIFY_BUSINESS_ANNUAL_INCOME: 'Renda anual',
  VERIFY_BUSINESS_BANK_STATEMENT: 'Extrato bancário',
  VERIFY_BUSINESS_BANNER: 'Verifique sua empresa para enviar seu primeiro pagamento',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_DESC:
    'Um proprietário beneficiário é qualquer indivíduo que direta ou indiretamente possui 25% ou mais da sua empresa.',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_TITLE: 'Proprietários beneficiários',

  VERIFY_BUSINESS_BENEFICIAL_OWNER_ADDRESS_QUESTION:
    'Qual é o endereço do proprietário beneficiário?',
  // New hardcoded strings that need translation
  VERIFY_BUSINESS_BENEFICIAL_OWNER_COUNTER: 'Proprietário beneficiário #{0}',
  VERIFY_BUSINESS_BUSINESS_CONTACT_DESC:
    'O representante comercial é o principal ponto de contato que gerenciará o relacionamento comercial e as operações contínuas com a Caliza.',
  VERIFY_BUSINESS_BUSINESS_CONTACT_TITLE: 'Contato comercial',
  VERIFY_BUSINESS_CITY: 'Cidade',
  VERIFY_BUSINESS_CNPJ: 'CNPJ',
  VERIFY_BUSINESS_CNPJ_FORMAT: 'O CNPJ deve seguir este formato: 12.345.678/9012-34',
  VERIFY_BUSINESS_CNPJ_QUESTION: 'Qual é o CNPJ?',
  VERIFY_BUSINESS_CNPJ_REGISTRATION: 'Registro de CNPJ',
  VERIFY_BUSINESS_COMMERCIAL_NAME: 'Nome comercial',
  VERIFY_BUSINESS_COMMERCIAL_NAME_QUESTION: 'Qual é o nome comercial da empresa?',
  VERIFY_BUSINESS_COMPANY_DETAILS_TITLE: 'Detalhes da empresa',
  VERIFY_BUSINESS_COMPANY_PROFILE_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_COMPANY_PROFILE_TITLE: 'Perfil da empresa',
  VERIFY_BUSINESS_CONTACT_INFORMATION: 'Informações de contato',
  VERIFY_BUSINESS_CONTACT_INFORMATION_QUESTION: 'Quais são as informações de contato deles?',
  VERIFY_BUSINESS_CONTACT_LABEL: 'Contato',
  VERIFY_BUSINESS_CONTACT_QUESTION: 'Quem é o ponto de contato para a empresa?',
  VERIFY_BUSINESS_COUNTRIES: 'Países',
  VERIFY_BUSINESS_CUSTOMER_COUNTRIES_QUESTION: 'Em quais países seus clientes estão localizados?',
  VERIFY_BUSINESS_CUSTOMER_DESCRIPTION: 'Uma descrição do seu cliente',
  VERIFY_BUSINESS_CUSTOMER_INDUSTRIES_QUESTION:
    'Which industries do you have customers in? Select all that apply',
  VERIFY_BUSINESS_CUSTOMER_QUANTITY_QUESTION: 'Quantos clientes aproximados você tem?',
  VERIFY_BUSINESS_CUSTOMER_TYPE_QUESTION:
    'What type of customers do you have? Select all that apply',
  VERIFY_BUSINESS_DOCUMENTS: 'Documentos',
  VERIFY_BUSINESS_DOCUMENTS_DESCRIPTION:
    'Please upload the company documents below. We support PDF, JPG, JPEG, PNG, and Word formats of a maximum size of [20] MB',
  VERIFY_BUSINESS_DOCUMENTS_TITLE: 'Documentos',
  VERIFY_BUSINESS_EMAIL: 'E-mail',
  VERIFY_BUSINESS_EMAIL_QUESTION: 'Qual é o e-mail deles?',
  VERIFY_BUSINESS_ENTITY_TYPE: 'Tipo de entidade',
  VERIFY_BUSINESS_ENTITY_TYPE_QUESTION: 'Qual é o tipo de entidade?',
  VERIFY_BUSINESS_EXPECTED_RANGE: 'Faixa $ esperada',
  VERIFY_BUSINESS_FINANCIAL_INSTITUTION_QUESTION: 'Are you a payment or financial institution',
  VERIFY_BUSINESS_FIRST_NAME: 'Nome',
  VERIFY_BUSINESS_INCORPORATION_DOCUMENT: 'Documento de incorporação ou estatuto social',
  VERIFY_BUSINESS_INDUSTRY_QUESTION: 'Em qual indústria sua empresa está?',
  VERIFY_BUSINESS_LAST_NAME: 'Sobrenome',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME: 'Nome da entidade legal',

  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_HELP:
    'Legal entity name must exactly match "NOME EMPRESARIAL" in your company\'s "CADASTRO NACIONAL DA PESSOA JURÍDICA" document.',
  // Additional tr() arguments that need symbols
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_QUESTION: 'Qual é o nome da entidade legal?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_DESC:
    'A legal representative is an individual with legal authority and powers to represent your company.',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_LABEL: 'Representante legal',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_QUESTION:
    'Who is the legal representative of this business?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_TITLE: 'Representante legal',
  VERIFY_BUSINESS_LICENSE_REQUIRED:
    'Are you required to have a license to operate in Brazil or another jurisdiction?',
  VERIFY_BUSINESS_MAIN_ADDRESS_QUESTION: "What is the company's main business address?",
  VERIFY_BUSINESS_MAIN_INDUSTRY: 'Indústria principal',
  VERIFY_BUSINESS_NATIONALITY: 'Nacionalidade',
  VERIFY_BUSINESS_NUMBER_OF_CUSTOMERS: 'Número de clientes',
  VERIFY_BUSINESS_OCCUPATION: 'Ocupação',
  VERIFY_BUSINESS_ONLINE_PRESENCE_DESC:
    'Please share any other websites or online channels that could help us to better understand your business. These include social media accounts, e-commerce stores, and app store links.',
  VERIFY_BUSINESS_ONLINE_PRESENCE_TITLE: 'Presença online',
  VERIFY_BUSINESS_OPERATIONS_TITLE: 'Operações comerciais',
  VERIFY_BUSINESS_OPERATION_COUNTRIES_QUESTION: 'Em quais países você opera?',
  VERIFY_BUSINESS_OPERATION_STARTED: 'Operação iniciada',
  VERIFY_BUSINESS_OPERATION_START_QUESTION: 'Quando a empresa iniciou as operações?',
  VERIFY_BUSINESS_ORGANIZATION_TITLE: 'Organização',
  VERIFY_BUSINESS_OWNER: 'Proprietário',
  VERIFY_BUSINESS_PERCENTAGE_OWNERSHIP: 'Porcentagem de propriedade',
  VERIFY_BUSINESS_PHONE: 'Telefone',
  VERIFY_BUSINESS_PHONE_NUMBER: 'Número de telefone',
  VERIFY_BUSINESS_PHONE_QUESTION: 'Qual é o número de telefone deles?',
  VERIFY_BUSINESS_POSITION: 'Posição',
  VERIFY_BUSINESS_POSITION_QUESTION: 'Qual é a posição deles?',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY: 'Procuração',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY_HELP:
    'Please provide a standing general Power of Attorney or a limited Power of Attorney that assigns authority to open accounts and sign contracts on behalf of the business',
  VERIFY_BUSINESS_SERVICES_DESCRIPTION: 'Descrição de produtos e serviços (Mínimo 8 palavras)',
  VERIFY_BUSINESS_SERVICES_QUESTION: 'Quais produtos ou serviços sua empresa oferece?',
  VERIFY_BUSINESS_SOCIAL_MEDIA_QUESTION: 'Quais são seus canais de mídia social? (Opcional)',
  VERIFY_BUSINESS_SOLE_PROPRIETOR_SKIP:
    'This section is not required since you are a sole proprietorship',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS: 'Fonte de fundos',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_TITLE: 'Fonte de fundos',
  VERIFY_BUSINESS_SOURCE_OF_WEALTH: 'Fonte de riqueza',
  VERIFY_BUSINESS_STATE: 'Estado',
  VERIFY_BUSINESS_SUITE_FLOOR_APT: 'Complemento',
  VERIFY_BUSINESS_SUPPORTED_ID_DOCS: 'Supported ID docs (Passport, DL or Registro Geral)',
  VERIFY_BUSINESS_TAX_ID: 'CPF/CNPJ',
  VERIFY_BUSINESS_THIRD_PARTY_QUESTION:
    'Do you intend to use Caliza to move funds on behalf of customers or other third parties?',
  VERIFY_BUSINESS_TITLE: 'Informações comerciais',
  VERIFY_BUSINESS_TYPICAL_CUSTOMER_QUESTION: 'Por favor, descreva seu cliente típico',
  VERIFY_BUSINESS_UPLOAD_ID: 'Carregar Passaporte, CNH ou Registro Geral',
  VERIFY_BUSINESS_URL: 'URL',
  VERIFY_BUSINESS_USD_VOLUME_QUESTION:
    'What is the expected monthly $USD volume you will move using Caliza?',
  VERIFY_BUSINESS_WEBSITE_LINK: 'Link do site',
  VERIFY_BUSINESS_WEBSITE_QUESTION: 'Qual é o site da sua empresa?',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_TITLE: 'Seus clientes',
  VERIFY_BUSINESS_ZIP: 'CEP',
  VERIFY_YOUR_BUSINESS: 'Verifique sua empresa',
  VET: 'Valor Efetivo Total',
  VET_TOOLTIP:
    'VET (Valor Efetivo Total) representa a taxa integral implícita, considerando spread, outras tarifas e impostos aplicáveis',
  VIEWER: 'Visualizador',
  VIEWER_DESCRIPTION:
    'Acesso apenas a leitura às contas da empresa, visualize e baixe o histórico de transações e relatórios de atividades',
  VIEW_ACTIVITY: 'Visualizar e baixar histórico de transações e relatórios de atividade',
  VIEW_AND_DOWNLOAD_TRANSACTIONS:
    'Visualizar e baixar histórico de transações e relatório de atividade',
  VIEW_USD_ACCOUNT: 'Visualizar conta USD',
  VIRTUAL_ACCOUNTS_COUNT: 'Contas Virtuais ({0} contas)',
  VOLUME_PROCESSED: 'Volume com margem',
  VOLUME_PROCESSED_TOOLTIP:
    'Inclui apenas transações concluídas em que a margem FX foi aplicada (ou seja, transações que geraram ganhos).',
  WALLET: 'Carteira',
  WALLET_ADDRESS_COPIED: 'Endereço copiado com sucesso',
  WALLET_BALANCE_CURRENCY: 'Saldo da carteira ${0} {1}',
  WALLET_BALANCE_LEGACY: 'Saldo da carteira ${0} Dolares digitais',
  WALLET_INFORMATION: 'Informações da carteira',
  WALLET_INFORMATION_WITH_CURRENCY: 'Informações da carteira ({0})',
  WEBHOOK_SECRET: 'Segredo de webhook',
  WEBHOOK_SECRET_ROTATED: 'Segredo de webhook rotacionado',
  WEBHOOK_SECRET_ROTATE_ERROR: 'Não foi possível rotacionar o segredo de webhook',
  WELCOME_BACK: 'Bem-vindo de volta',
  WELCOME_TITLE: 'Bem-vindo de volta, {0}',
  WE_ARE_DEPOSITING_YOUR_FUNDS: 'Estamos depositando seus fundos',
  WE_DONT_SUPPORT_YOUR_COUNTRY_YET: 'Ainda não oferecemos suporte ao seu país',
  WE_RECEIVED_PAYMENT_INITIATED: 'Recebemos seu pagamento e iniciamos sua transferência',
  WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION:
    'Confira seu histórico para acompanhar o status da transferência. Os detalhes da transação podem levar alguns minutos para aparecer.',
  WHERE_SENDING_FUNDS: 'Para onde você está enviando fundos?',
  WHO_ARE_YOU_DEPOSITING_FOR: 'Para quem você está depositando?',
  WHO_ARE_YOU_SENDING_FUNDS_ON_BEHALF_OF: 'Em nome de quem você está enviando fundos?',
  WIRE: 'Transferência bancária',
  WITHDRAW: 'Retirar',
  WITHDRAWAL: 'Retirada',
  WITHDRAWAL_ACCOUNT: 'Conta de retirada',
  WITHDRAWAL_TO: 'Saque para {0}',
  WITHDRAWAL_TRANSACTION_HASH: 'Hash da transação de saque',
  WITHDRAW_FUNDS: 'Retirar fundos',
  YEAR: 'Ano',
  YES: 'Sim',
  YOU: 'Você',
  YOURE_ALMOST_DONE: 'Você está quase terminando!',
  YOUR_ACCOUNT: 'Sua conta',
  YOUR_ACCOUNTS: 'Suas contas',
  YOUR_BALANCES: 'Seus saldos',
  YOUR_CALIZA_PASSWORD: 'Sua senha da Caliza',
  YOUR_EARNINGS: 'Seus ganhos',
  YOUR_FUNDS_HAVE_BEEN_ADDED: 'Seus fundos foram adicionados',
  YOUR_FUNDS_HAVE_BEEN_SENT: 'Seus fundos foram enviados',
  YOUR_FX_MARKUP: 'Sua margem FX',
  YOUR_ORGANIZATION: 'Sua organização',
  YOU_CLAIM: 'Você resgata',
  YOU_DO_NOT_HAVE_ENOUGH_FUNDS: 'Você não tem fundos suficientes para concluir esta transação',
  YOU_PULL_FROM_CUSTOMER: 'Você retira do cliente',
  YOU_RECEIVE: 'Você recebe',
  YOU_SEND: 'Você envia',
  YOU_STILL_BE_ABLE_TO_EXPLORE_PRODUCT_DESCRIPTION:
    'Você ainda poderá explorar nossos produtos, mas não poderá enviar pagamentos. Iremos notificá-lo assim que estivermos ativos no seu país.',
  ZERO_RESULTS_FOUND: '0 resultados encontrados',
  ZIP: 'CEP',
};
export default strings;
